import type { LabSandboxConfiguration } from 'bundles/labs-common/types/LabSandbox';

// Hard-coded from https://tools.coursera.org/epic/experiment/kzM9UKfaEeuInmG6gV2Kwg
// Course IDs as keys intentionally violate this rule
/* eslint-disable camelcase */
export const labSandboxCourseConfiguration: Record<string, LabSandboxConfiguration> = {
  'Hq7dl9ELEeWB-BI5fjMtHQ': {
    courseSlug: 'bayesian',
    computerLanguages: ['R'],
    itemIds: [
      'vveXO',
      'CgEI1',
      'ilz2Q',
      'vveXO',
      'sgokx',
      'QzirB',
      'RIhq3',
      'ZHntt',
      'PqAP1',
      'J7ann',
      '7Fu5H',
      'd72Rm',
      'RN35r',
      'k19ZL',
      'xF1rQ',
      'SsFcG',
      'z52as',
      'pAuD5',
      'LHK3R',
      'hjOGb',
      '3ky4H',
      'uHLUg',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorgjbnjgru',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'pn1erK4cEeaP-Q4_2QdcFg': {
    courseSlug: 'server-side-nodejs',
    computerLanguages: ['Node.js'],
    itemIds: [
      'uUTRR',
      'ROhIL',
      'ASLvQ',
      'cJvzp',
      'TIYSl',
      'U1OXb',
      '75pR8',
      'DdJt7',
      'iQ9cI',
      'J5vUP',
      'HDaxH',
      'JghiK',
      'kQAYt',
      'VOFzK',
      '8OjGV',
      'UPiVe',
      '9Lbql',
      'HAaAj',
      'XIMQE',
      'mpNR7',
      '7qUMG',
      'vWfOo',
      '0qvBJ',
      'xHpZO',
      'pIEj5',
      'wjfQc',
      'F1GIQ',
      'y3zWc',
      'VQrXd',
      'ouexI',
      'H5RKY',
      '7TuVm',
      'lHl20',
      'eoZuX',
      'DuQfi',
      'HlSd3',
      'P5A8a',
      'yb7jY',
      'Vge40',
      'aMH8q',
      'Muj6o',
      'QtBvG',
      'uhgMP',
      'UboBt',
      'yHuIA',
      'M1M3T',
      'G31sb',
    ],
    launchPath: '/',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorhduelitf',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  HkJsxW0yEeWEewoyD2Bc5Q: {
    courseSlug: 'data-cleaning',
    computerLanguages: ['R'],
    itemIds: [
      'kPOKW',
      'cqzOk',
      'k2arZ',
      'RJBrZ',
      'hTfQ5',
      '9W3Y2',
      'FIZtT',
      'WVUUP',
      'keVzH',
      'JYMiZ',
      '50qSe',
      '9NehX',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorowlcswkc',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  HITLfhnoEeWjrA6seF25aw: {
    courseSlug: 'website-coding',
    computerLanguages: ['HTML, CSS, and JavaScript'],
    itemIds: [
      'Z4m0k',
      '7CPxn',
      'LHtzD',
      'LSewU',
      'xJ3FZ',
      'VDT6L',
      'dIM6w',
      'gY8yE',
      'Mzjcv',
      'EdvAc',
      'onCTe',
      'MereL',
      'ShSD4',
      'ARN04',
      'ZWRAU',
      'stvdR',
      'pQqDG',
      'MZHuk',
      'ZSi9j',
      'nRJb3',
      'ywyJe',
      'zqO7D',
      'AgqfH',
      'GrRHH',
      'ZRy54',
      'wOS5D',
      'jl7td',
      'DC5gS',
      'VDGQJ',
      'a5q6Z',
      'BFSGc',
      '6tmRp',
      'FvO52',
      'qop2Z',
      '5kuS6',
      'znGns',
      'mPdRW',
      '5HpWL',
      '5oc3L',
      '5ctOU',
      'ZA9Ri',
      'MFuKl',
      'MZHuk',
      'f4PxN',
      'HJYKJ',
      'Yi1fQ',
      '4joUx',
      'P86AJ',
      'TGHfW',
    ],
    launchPath: '/',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorxskwonzd',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  _8FRmSXkEeeCDQ44DPGlIA: {
    courseSlug: 'sql-for-data-science',
    computerLanguages: ['SQL'],
    itemIds: ['P95G0', '5gUCI', 'qtwVG', '9QZ4J', 'URsR2', 'QA3wg', 'KddLO', 'YGpe2', 'cCOUv', 'fC8aC', 'lBaEP'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorvpkhwlvd',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  iSxVEG07EeW3YxLB1q9I2w: {
    courseSlug: 'data-scientists-tools',
    computerLanguages: ['R'],
    itemIds: ['DQjS5', 'FA3Kg', 'EOJLO', '9PzNv', '7Gm8v', 'bGzw3', 'tOSqB', '0F4l7', '35IwV'],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorlugkzzgb',
    excludeBranchIds: [],
  },
  L9xlYnblEeaCZBIelfdoiQ: {
    courseSlug: 'algorithms-npcomplete',
    computerLanguages: ['Algorithms'],
    itemIds: [
      'cnDtw',
      'xF6pp',
      'Sj8BZ',
      'WuAkl',
      'nrssO',
      '4lIh5',
      '9YPKE',
      'Pfiab',
      'e1GSG',
      '6wkr6',
      'NHBRg',
      'tOw2s',
      'wmqTR',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorvyccghlh',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  nCS5FnYhEeeRdgqk8_JAvA: {
    courseSlug: 'introduction-mongodb',
    computerLanguages: ['MongoDB'],
    itemIds: [
      'Hadhu',
      'iX9z0',
      'OwBDM',
      '257fQ',
      'J5kZW',
      'f5IAo',
      'Opyp1',
      'Mc7RF',
      'SKYCv',
      'ovj7A',
      'gEspG',
      'EJtdO',
      'gaQh9',
      'QOzcu',
      'yBa9v',
      'Iozkp',
      'roCuP',
      'cCESM',
      's9Hp1',
      'icnWk',
      'qGJNU',
      'yVNyz',
      'Xov4o',
      'OEBBr',
      'YzYrF',
      'KY74S',
      'XIKbc',
      'X0W2L',
      'Rl4n6',
      'suVj5',
      'AUmbh',
      'pI6K3',
      'ltphI',
      'Vd1Em',
      'mTZmx',
      '8xIDD',
      'dygBl',
      'wPrHv',
      'emRtM',
      'qEcaC',
      '7UYu0',
      'YVbPR',
      '1a0Ix',
      'JYc0S',
      '7yYF0',
      '6EuMX',
      'YPsLO',
      'rIeGZ',
      'HMTKs',
      '3BR9E',
      '4rpnU',
      'OsWfX',
      'OsWfX',
      'SGyW6',
      'o3xiB',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorjmkjmeod',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '6JyoHjVOEeWBMQ5pdIoFkQ': {
    courseSlug: 'data-visualization',
    computerLanguages: ['Python'],
    itemIds: ['z4VnK', 'ntBWz', 'DwLkL', 'qmPuH', 'SwecK', 'KMf3t', 'FilDp'],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorltimrhma',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'gja-ZYNWEeWxQQoymFg8zQ': {
    // Also used in lab-sandbox-auditLearner.test.ts and lab-sandbox-paidLearner.test.ts because these need real public launched courses and items
    courseSlug: 'global-warming-model',
    computerLanguages: ['Python'],
    itemIds: [
      'PZk8b',
      '1eKdK',
      'Xq8qc',
      '260LO',
      'V2lcJ',
      't8bz4',
      'QSiHE',
      'LexxY',
      'lW5Vh',
      'v4gnf',
      'VPLJj',
      'cQzEu',
      'mkJZg',
      'WRGJR',
      'aK0dY',
      '023Rg',
      '5Y47w',
      'SYezd',
      'g3MvX',
      'jXkPb',
      'GKa6j',
      '4sKUZ',
      'n7P1n',
      'dfTwX',
      'GQC5B',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorhefkvact',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'guqOkAKDEeaG2A4kH1tj-w': {
    courseSlug: 'probabilistic-graphical-models',
    computerLanguages: ['Octave'],
    itemIds: [
      'sms6v',
      'Pl2zP',
      'yVzzh',
      'Ae3gm',
      'gq9jy',
      'cHoUG',
      'EbAqS',
      'reE7c',
      'EOHv6',
      'SsIkl',
      'mdMW3',
      'hdDcV',
      'RfgDv',
      'vXUoZ',
      'kOCHO',
      'z2JNd',
      'D2fDR',
      'dZmtj',
      '5MNWr',
      'K6YVG',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructordpsbuhcb',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '-634YPnoEeaOTwrEsgnL9g': {
    courseSlug: 'programming-fundamentals',
    computerLanguages: ['C'],
    itemIds: [
      '4S7bf',
      'svcTw',
      '9WekC',
      'T7sSM',
      'lncY0',
      'EE0qY',
      'Oqj4Z',
      'zGR19',
      'Yug08',
      'sFHjX',
      'aMVT8',
      'rBnMJ',
      'ZAZ1r',
      'MGpLy',
      'Iiqyq',
      'y7Yt3',
      '3iOjO',
      'otME3',
      'pw31u',
      '7ppc6',
      'NDmmY',
      'l4zQL',
      '16ZXn',
      'Zouek',
      'TxM1H',
      'gSJnU',
      'IHw3N',
      'XKeBN',
      'xq0jt',
      'zb2ND',
      '4yZ0t',
      'jGewQ',
      'zZFOA',
      'KNbn9',
      'pu8s1',
      'Lam0f',
      '9khxH',
      '6GJul',
      'uS1Fh',
      'LGW4U',
      'cCZYY',
      'BPARU',
      'mxjvk',
      'kznvG',
      '8LVp2',
      'FNpyF',
      'cnOw6',
      'X1hv3',
      'dR3HR',
      'usAjT',
      'CL9jP',
      'gO5A1',
      'RoNez',
      '9PpYi',
      '72zch',
      't2McG',
      'Xmf4T',
      'pqlRm',
      'VBsOa',
      '4F2uM',
      'kTVdC',
      'LJVcg',
      'SCzBA',
      'Je0wn',
      'nvGMS',
      'YouIS',
      'BOTAW',
      'vcBUV',
      '2m82h',
      'X2IzY',
      'DFE8U',
      'RHNQz',
      'X1KBH',
      'vAVka',
      '9LmqH',
      'e9vap',
      'Xkk9A',
      'ABM0B',
      'a7zEW',
      '2siIb',
      'e1MgU',
      'TcnbL',
      'R1HQ1',
      'YOWXY',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorzogkvrca',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  mxdq5kIJEeWC4g7VhG4bTQ: {
    courseSlug: 'ml-regression',
    computerLanguages: ['Python'],
    itemIds: ['B6CdC', 'KXEJ3', 'tcfe4', 'MhFOa', '64hYu', 'poz6z', 'qsV5O', 'dtsUT', 'dQJGs'],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorhpxjhtqg',
    excludeBranchIds: [],
  },
  NJWa6CDkEeWa6hIFcmm3AQ: {
    courseSlug: 'responsive-website-examples',
    computerLanguages: ['Meteor.js'],
    itemIds: [
      '9iMMq',
      'MbQUn',
      'Y7eBc',
      'cQ4ho',
      'ZfieY',
      'C4lp4',
      'AmHuH',
      '0OclZ',
      'f2COq',
      'p7VGZ',
      'i9mrq',
      'evDyb',
      'EhvE6',
      'ebrVf',
      'oiXqI',
      'yuSIt',
      'SBpPb',
      'vFSDU',
      'XatKE',
      'AZvha',
      '3hJnR',
      'r30yp',
      'ftOyh',
      'gDqQG',
      'xZA0A',
      '6ZmOM',
      'FUqnD',
      'zzbXR',
      'WWmui',
      '7QbX2',
      '4Yn6m',
      'O8flX',
      'ILHL7',
      'R0aKR',
      'ILKLw',
      'NFtB2',
    ],
    launchPath: '',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorfzzrsdao',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'yOZEQ3lwEeWb-BLhFdaGww': {
    courseSlug: 'data-structures',
    computerLanguages: ['C++, Java, and Python3'],
    itemIds: ['0mg6B', 'Xscmz', 'sLjtY', 'b66y2', 'kAiGl', 'w9YDz', 'ekN4T', 'nZrTS'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorkrfadwsb',
    excludeBranchIds: [],
  },
  CPy7BAtMEeeyDAoXlzPrFg: {
    courseSlug: 'crash-course-in-causality',
    computerLanguages: ['R'],
    itemIds: ['TZ01D', 'VtFdu', 'lAeza', 'MbcoE', 'Ie48W', 'wEyaG', 'D19Ae', 'czisS'],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorvtrhhpkd',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  yzaI66h4EeeDkArsR_C2QA: {
    courseSlug: 'c-for-everyone',
    computerLanguages: ['C'],
    itemIds: [
      'tGxfO',
      'EnzrH',
      'ndyjt',
      '28Swr',
      'MH6Mr',
      'gDy0q',
      'DeQEK',
      'UXaXd',
      'jYAko',
      '4d0Qa',
      'z147s',
      'xlVLL',
      'x7Hbd',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorykanyfsd',
    excludeBranchIds: [],
  },
  Vh4RJTk8EeWJaxK5AT4frw: {
    courseSlug: 'introcss',
    computerLanguages: ['HTML, CSS, Javascript'],
    itemIds: [
      'egY1Z',
      'Z0pee',
      'wUVuR',
      'QUd5I',
      'T0r3d',
      'CZi04',
      'Gmzk3',
      'trNtz',
      '6YqCl',
      'C9NkD',
      'JW2xb',
      'bzbtj',
      'NTcrS',
      'lWEKl',
      '9Ps4p',
    ],
    launchPath: '/',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorhqmkikwg',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'maX993EhEeWi0g6YoSAL-w': {
    courseSlug: 'web-app',
    computerLanguages: ['Ruby and Rails'],
    itemIds: [
      '68i5f',
      'uiPft',
      'B8tNi',
      'dOglM',
      'zMT48',
      'ZBbdW',
      'EYbTn',
      '1JaBU',
      '3qWvQ',
      '6B1jX',
      'mbG2r',
      'XhiHr',
      'wy1VV',
      'CGNiI',
      'FjW8w',
      '12wph',
      '6LWRc',
      'NxheD',
      '5sGkS',
      'ABlXX',
      'FDuqX',
      'Jp0j5',
      'dFvuu',
      'ahpdY',
      'sSvxD',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorzrsicpgo',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  R8rsoKfPEeiS7RI0Mi1tOA: {
    courseSlug: 'relational-database',
    computerLanguages: ['MySQL and creating Entity Relationship Diagrams (ERDs)'],
    itemIds: [
      'JLn9e',
      'G6c93',
      'fndX3',
      'I8mEY',
      'PJgAC',
      '4fVkc',
      'IRz8B',
      'cROBn',
      'b9a6Q',
      'N9Dfv',
      'ktEmU',
      'dOnbU',
      'vaoz1',
      'GdW36',
      'eIyTD',
      'HzZmf',
      'W8bt3',
      'tqm7E',
      'Wb26f',
      'Ves8F',
      'WdwrZ',
      'ErfoX',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructortlzawypu',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'hwiBZm0vEeWbyw5d8C-Blw': {
    courseSlug: 'exploratory-data-analysis',
    computerLanguages: ['R'],
    itemIds: [
      '25n7f',
      'onm0m',
      '85hM5',
      'uR7w0',
      '9V4dG',
      'ylVFo',
      'jojEL',
      '41Udz',
      'pzr2X',
      'WATEh',
      '72TDH',
      'bDtUl',
      'viGLK',
      'xBrnt',
      '7ERgJ',
      'HFZxo',
      'b5Ecl',
      'Os56c',
      'XAPK7',
      'TNo9D',
      'jIuYD',
      '0MEib',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorutqlwntm',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  mjoddspaEey3GgqQBm7DaQ: {
    courseSlug: 'coursera-lab-sandbox-authoring-inhouse-q1-2022',
    computerLanguages: ['HTML and CSS (please only use this sandbox for practice and not graded activities)'],
    itemIds: ['9Z3bz'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorgrjqgsal',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '9u1jAWLFEeWUshLcukZCkw': {
    courseSlug: 'linear-models',
    computerLanguages: ['R'],
    itemIds: [
      'BYUXz',
      'QYpIZ',
      'wAQ6R',
      '0atLF',
      'ZJJWN',
      'yzZDt',
      'mT9bn',
      'ZEE6D',
      '7mEFo',
      '74Tn8',
      '4FjMZ',
      '6JGtH',
      'RF9Oy',
      'KVlUx',
      'JPmVJ',
      'uLwfU',
      'XS9hr',
      '8BY8I',
      'rdkzP',
      'TbfoZ',
      'jAdBV',
      '5pYAA',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorknfhyjtu',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  A97cQkR4EeawVwo82dylKw: {
    courseSlug: 'r-programming-environment',
    computerLanguages: ['R'],
    itemIds: ['ORF4Q', 'tsf3d', 'hNMtk', '61c3J', 'dkN0v', 'dspzD', '6loPJ', 'ih5uK', 'VIqDB'],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorfwjuguuf',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  zfksZy_FEeWWqBIFfWmDPQ: {
    courseSlug: 'data-manipulation',
    computerLanguages: ['Python, R, and SQL'],
    itemIds: [
      'MSzAB',
      'RK0aI',
      'AxbQn',
      'nkglo',
      'Dp7qI',
      'PlL4J',
      'FR0Ke',
      '6JV6s',
      'S40H6',
      'wiPbb',
      '3uBRq',
      'b7Uh4',
      'TxtOa',
      '7kZQ6',
      'NT7m3',
      'wimSB',
      'zjeM1',
      '5oK1y',
      'czgP4',
      'Lm1VY',
      'LBLUh',
      'owjMR',
      '0V0Gu',
      'LzEBt',
      'khmOZ',
      'NWgaE',
      'B4aRJ',
      'SNJY5',
      'QW35z',
      'Ugdel',
      'qTMZM',
      'Gyfm1',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorsaomsbab',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  ENhHCTboEeW8ZAoCexam_w: {
    courseSlug: 'data-analysis-tools',
    computerLanguages: ['Python'],
    itemIds: [
      'ERzUa',
      'MWLEx',
      'dsim7',
      '1QGTx',
      'UUM0c',
      'EaMOi',
      '84OFT',
      'te8hb',
      'K7ARD',
      'kELME',
      'hSo2f',
      'F9YsY',
      'NjI87',
      '3bv5A',
      '6nHBL',
      'WZt9l',
      'Qc7C3',
      'hLFMG',
      'nhp1Q',
      '5CeHm',
      '7rf6V',
      'ElVbC',
      'GCox2',
      'uMNjz',
      'gasIg',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorrprazxwn',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '3VZYG4kSEeiCEBJK_HZFrg': {
    courseSlug: 'meaningful-predictive-modeling',
    computerLanguages: ['Python'],
    itemIds: [
      'pUoNX',
      'TS2W5',
      'AtLSi',
      'aVNfu',
      'JUVzr',
      'QGC4R',
      'ds69q',
      '8kI1X',
      'wV089',
      'QWnnS',
      '25pE3',
      'uqLGf',
      'fKf5h',
      'YwBsy',
      'dW53V',
      'uI7ew',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorywcwtaay',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '__y3wBnnEeW9dA4X94-nLQ': {
    courseSlug: 'java-programming',
    computerLanguages: ['Java'],
    itemIds: [
      '3POXr',
      'ugDUZ',
      'gvoNh',
      'HpHRk',
      'vsOTl',
      'igoM1',
      'EXkq5',
      'MtNlQ',
      '7w8J0',
      'Qidpv',
      'YxFip',
      '6CLKD',
      'xwE4F',
      'IS0Wi',
      '3ML6Y',
      'UaD2C',
      'KlXlY',
      'PO8FJ',
      'OOBvA',
      'X5uv4',
      '4z1AW',
      'zhwPW',
      'XNKp2',
      'RDTcP',
      'eDDVI',
      'TijnH',
      'Nl6iU',
      'gNZVc',
      'tGrdZ',
      'BNtuk',
      'kVCHZ',
      'q4k6Z',
      'IpUp4',
      '2Vw7Q',
      'zJYgx',
      'cI1Vw',
      'Au4c3',
      'ct8gA',
      'S5Ih4',
      'eS8iB',
      '1k2j7',
      'AML8i',
      'KAeBR',
      'UUL0Y',
      'UGYoK',
      'kNS01',
      'T8W0j',
      'hEIbT',
      'XE4ve',
      'NEK0h',
      'GtEyZ',
      'ZGv61',
      '0Xc9B',
      'mZMXO',
      'hSJlh',
      'ZqwsK',
      'oE2de',
      'TaQsz',
      'by9e2',
      'UmhBC',
      'FzhKr',
      'f062g',
      'zYkbA',
      'qFeyj',
      '56G8m',
      '2nfvZ',
      'NcRjb',
      '0z09j',
      'f8W8D',
      'wkC85',
      '6P96D',
      'lFms6',
      'NAOe3',
      '0dSeC',
      'EvDlD',
      's4ENY',
      'LyJ0p',
      'nwtSx',
      'Qu17T',
      'fAJ2f',
      '8Xv0j',
      'RjG3E',
      '4vNS1',
      'jKQvY',
      'Aq71Q',
      'mfkCj',
      'owuLP',
      'tlOL3',
      'ESdCA',
      'cSnvX',
      'X0D39',
      'eCYAO',
      'PeDCh',
      '3gm01',
      '64TJm',
      'VeM7L',
      'QLf1e',
      'h8JNz',
      'IyIih',
      'g3fX6',
      'Okei2',
      'tlOL3',
      'ESdCA',
      'cSnvX',
      'X0D39',
      'eCYAO',
    ],
    launchPath: '',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorajexcyqv',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  bmz_ySlYEeuYhAqtdVtiGw: {
    courseSlug: 'dcf-311',
    itemIds: ['HOCN5', '4SEaK', 'd4sXg'],
    launchPath: '',
    comment: 'e2e test course. Do not remove.',
    instructorWorkspaceId: 'instructorwvqethda',
    excludeBranchIds: [],
  },
  'wQ9FD3b0EeaahA7WQe-h_w': {
    courseSlug: 'algorithms-graphs-data-structures',
    computerLanguages: ['Algorithms'],
    itemIds: [
      'kdK1P',
      'rOtFq',
      'mlBXG',
      'Ij5au',
      '4UEbX',
      'xHTaZ',
      'n8XfJ',
      'HPLlG',
      'mBvZq',
      '8TSS7',
      'v8OPB',
      'tDq29',
      'nIVnJ',
      'unF8B',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorzufhewva',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  NYVeK3blEea0bBInbpCXBQ: {
    courseSlug: 'algorithms-greedy',
    computerLanguages: ['Algorithms, Trees, and Dynamic Programming'],
    itemIds: [
      'Wt63m',
      'bBxNY',
      'u4WGg',
      'rCrms',
      'Ynwfz',
      '81Gw8',
      '4KTJt',
      'qfnQy',
      'UtaAN',
      'nrssO',
      'fyQjF',
      'KLIrO',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorfrbavfdx',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  w8XUd6IPEeabYQqQ7YU7Bg: {
    courseSlug: 'mcmc-bayesian-statistics',
    computerLanguages: ['R'],
    itemIds: [
      '2JlQE',
      'Hva1K',
      'eWn7B',
      'BMZrs',
      'wnOz5',
      'XKbXM',
      'PjeNi',
      'wzlhE',
      'OXNNH',
      'm1Flj',
      'tcYKf',
      'xsW8W',
      'PKG2h',
      'bCeY1',
      'ExW2e',
      'z2w1J',
      'U2kyr',
      'ADlJc',
      'f0MgF',
      'WIukj',
      'U6enW',
      'CTouY',
      'q3B0G',
      'Xtxy8',
      'MO97o',
      'AibaK',
      'KDYW9',
      'gOosf',
      'RoN7n',
      '9F61M',
      '323gO',
      'Y4VDB',
      '6cs8Q',
      'RA1na',
      'J91Lf',
      'e0SLd',
      'w1uRW',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructoroqvavcxl',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  RMFRum1BEeWXrA6ju0fvnQ: {
    courseSlug: 'r-programming',
    computerLanguages: ['R'],
    itemIds: [
      'lB1sR',
      'NUerb',
      'jRIsk',
      'Xnxtv',
      'Obj7V',
      'BvK2b',
      'sYn1q',
      'SdGoO',
      'mfPBZ',
      'U2IhO',
      '2yM63',
      'R8pfM',
      'amLgW',
      'dFoWF',
      '5VoF3',
      'b8XDD',
      'hZgBh',
      'tNy8H',
      'qozqm',
      'mWchY',
      '72i8y',
      'zaa3o',
      'w1c7p',
      '8JIT0',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorbwviwtkt',
    excludeBranchIds: [],
  },
  nZYl8m_GEeeLuxKawECaMg: {
    courseSlug: 'combinatorics',
    computerLanguages: ['Python'],
    itemIds: [
      'HYmdm',
      'ytKEC',
      'VZ57h',
      'vmWqf',
      'Tv5V9',
      'N214m',
      'X4xOq',
      'UxP4G',
      'sB7g6',
      'WZaLl',
      'mGIVQ',
      'W5eRo',
      'akJLq',
      'cjHuV',
      '2gl8E',
      'E1CA5',
      '3CgkM',
      '1nBgB',
      'PxaCn',
      '4d3s2',
      'yCm1W',
      'x59Ho',
      '5kdtY',
      '7poMm',
      'laVGU',
      'AzC9W',
      '16BQW',
      'Q14cX',
      'DsQ89',
      'VY0kF',
      'KkL5z',
      'VF5Ng',
      'TvdE9',
      'sTHyM',
      'kkP9H',
      'ECHWz',
      'ig9u2',
      'JHxZ3',
      'V9pnr',
      'OkRwU',
      'oVKfk',
      'x2ACA',
      '7zg0j',
      'nBt5t',
      'tflok',
      'vtVdB',
      'LvgGe',
      'iiIBS',
      'cD668',
      'JbgcJ',
      'Gpx8u',
      'c3RuS',
      'AmBvy',
      'ksKeA',
      'XoGhy',
      'iSSWk',
      'VKsgP',
      'B1tJS',
      'wuTII',
      '3sYtb',
      'i6aCC',
      'YN3jP',
      'u7kfZ',
      'kQolv',
      'OYtGc',
      'JCUM2',
      'Zvqe6',
      'PBc9V',
      'pcvif',
      'AZZLd',
      '4iUF8',
      'qfLeR',
      'xwuji',
      'sqAyt',
      'bGWmV',
      '5anYc',
      't9oRv',
      'dD8OQ',
      'fp6NS',
      'e9X31',
      'sjCPc',
      'xzzPH',
      'UE2Pb',
      'sCCmy',
      'mgUDq',
      'QNkLW',
      'jpvZ5',
      's44Fv',
      '2ky4n',
      '55zyO',
      'qdj2Z',
      'jM7qj',
      'NCwzq',
      'cyUx7',
      'bVrs3',
      'vrm8H',
      'p5kqt',
      'FK1Oh',
      'Rig8n',
      'lKG5O',
      'BKWNq',
      'TvbFA',
      'mx2IM',
      'Zx5FH',
      '71vBb',
      'DZbh8',
      '27o4u',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorpzeycflz',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '-N44X0IJEeWpogr5ZO8qxQ': {
    courseSlug: 'ml-clustering-and-retrieval',
    computerLanguages: ['Python and Machine Learning'],
    itemIds: [
      'gJSfc',
      'nC8Mq',
      'mMipk',
      'itzL5',
      'E26k9',
      '2yRba',
      'XbP9U',
      'UnnXU',
      'XGgeJ',
      'unHNR',
      'OL4J1',
      'LXSnc',
      '57vnY',
      'QBFNf',
      'iF7Ji',
      'YV0W4',
      '0acPr',
      '7cVMj',
      'tHtXY',
      'dlBVz',
      'QVHj1',
      'd6s1W',
      '6ieZu',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorsfggdcqq',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'd0Vop3l1EeW3pg6oA-kqJQ': {
    courseSlug: 'assembling-genomes',
    computerLanguages: ['Python, C++, Java'],
    itemIds: ['bXCHa', 'zDGW4', 'ciMBl'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorouudksst',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'sZ-yG-mDEee1pg7iGbQOEg': {
    courseSlug: 'intro-to-numerical-analysis',
    computerLanguages: ['Python'],
    itemIds: [
      'x0yVf',
      'nCvMx',
      'V9Ozc',
      'NPE9O',
      'q6cmt',
      'kTGPA',
      'mp8ry',
      'Qftpp',
      'PWygf',
      'Na03A',
      'fgfaz',
      'Y6RwH',
      'fDsxj',
    ],
    launchPath: '',
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorrrsxlero',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  XUoQOTbqEeWoUw6Yc8vnEw: {
    courseSlug: 'regression-modeling-practice',
    computerLanguages: ['Python'],
    itemIds: [
      'oJLz9',
      '0cW88',
      'iovZw',
      'h1RlU',
      'OMBQn',
      'OzYcB',
      'jiHOZ',
      'zjmXI',
      'pddSO',
      'sLhjw',
      'zt6KR',
      '1FGNW',
      'RUvEv',
      'mXeMl',
      'xQRab',
      'E3pjy',
      'q2xna',
      'lGvK9',
      '1Oh3Z',
      'X77pa',
      'UCzPC',
      'okHmV',
      'whCsG',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorrixicjcw',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  qogqSFgBEeWBNwpVGuknww: {
    courseSlug: 'biostatistics',
    computerLanguages: ['R'],
    itemIds: ['jgMaN', 'tiqUM', 'azo7M', 'AYoMS', 'OgPpu', 'o1AdW', '3ZGtq', 'gvnXl'],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorptgyxnjf',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  r32oHRuLEeWxXBLj8jbgsw: {
    courseSlug: 'cryptography',
    computerLanguages: ['C'],
    itemIds: [
      '6A3cX',
      'rK70X',
      '4dzku',
      '01t8O',
      '7mgaE',
      'sVTPm',
      'J7nrY',
      'wXerf',
      'EZsBb',
      '98B9L',
      '9LFA4',
      'wXsjy',
      'VBIGB',
      'h8Rz8',
      'c4bnf',
      'okKCx',
      'B6HMM',
      '3Iajv',
      'mv1YH',
      'J3Ruz',
      'GgyVZ',
      'mniuf',
      'us7Qf',
      'h10au',
      '34ORc',
      '3MYyu',
      'zaK8x',
      '7JUGl',
      '7CqCh',
      'MNCl9',
      'mwhGL',
      'j3ccC',
      'IqxQv',
      'mONIl',
      'DZHVe',
      'okPgl',
      '6552v',
      's8bfB',
      '6OShB',
      'n6sNH',
      'IjNjm',
      'BSNVw',
      'zXYf0',
      'cYZYt',
      'pqhXY',
      'be3ae',
      'tT3Yx',
      'BSzDM',
      '40Sb3',
      'PkajS',
      'TaZD2',
      'HK4S2',
      'EujaZ',
      'WvcI3',
      'fmeqB',
      'QmuUo',
      'l6OUg',
      'dBl92',
      'yx182',
      'AAlnZ',
      '3uUUD',
      'xlbL2',
      'bgRyW',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorawkdhbom',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  Anu7oplDEeWqkw5zNB248Q: {
    courseSlug: 'statistical-genomics',
    computerLanguages: ['R'],
    itemIds: ['NcgMK', 'yeJL6', 'bPRJM', 'y6RcL'],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructornwsttgac',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  nA4RUW01EeW8nRIpKnwp7Q: {
    courseSlug: 'algorithmic-toolbox',
    computerLanguages: ['Java, C++, Python'],
    itemIds: [
      'eldsL',
      'sLjtY',
      'P2hHu',
      'Bskph',
      'LYB9i',
      'EkxIX',
      'DNH3L',
      'oCUw3',
      'Xscmz',
      'CDZh6',
      'gTD7f',
      'qTKGP',
      'b66y2',
      'rqsqd',
      'kAiGl',
      'V5ol6',
      'w9YDz',
      'ekN4T',
      'nZrTS',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorvkxzrhzm',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  qLFYrxnoEeWwrBKfKrqlSQ: {
    courseSlug: 'database-management',
    computerLanguages: ['SQL'],
    itemIds: ['jvqBF', '2Zb7z', 'SlJs2', 'IbjuR', '3wRSC', '2ZrK4', 't5jso', 'NfS0O', '0X1Ry', 'R8IJS'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorwbnqmgfo',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  Eeb34jesEeWXuQopUhAqaw: {
    courseSlug: 'java-programming-recommender',
    computerLanguages: ['Java'],
    itemIds: [
      'Ny23T',
      'ILMcl',
      'VQbIK',
      'UakVx',
      'KTrOQ',
      'Ud6RD',
      'hzeKw',
      'E9Xy0',
      'XR64e',
      'oDs9P',
      '433EU',
      'v6zi0',
      'uOSDs',
    ],
    launchPath: '',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorddgrelur',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  g9KhGjk_EeWXuQopUhAqaw: {
    courseSlug: 'responsivedesign',
    computerLanguages: ['HTML, CSS, and Bootstrap'],
    itemIds: [
      '6MUTk',
      'D8W4n',
      'URnl0',
      'dQndg',
      'mMkPC',
      'iHbe9',
      'TK4CK',
      '8dIa2',
      'ssiNo',
      'fd50Q',
      'wZGGp',
      '2djnP',
      'opt7D',
      'LBzQM',
      'x7dlR',
      '17cwr',
      'DDtg7',
      'bd0U9',
      'NKHvB',
      'bbH2F',
    ],
    launchPath: '/',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorvthsptck',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '7KOMkK4bEeaXlg7d4yL0LA': {
    courseSlug: 'angular',
    computerLanguages: ['Angular, TypeScript, and HTML'],
    itemIds: [
      '0D5ye',
      'Kvmma',
      'tK5st',
      'LGucr',
      'nTVoM',
      'Rgc7B',
      'cgFr3',
      'uokSs',
      'ggdNK',
      'ohvG4',
      'cnuol',
      'wyg4e',
      'Cz6ZK',
      'z0WEU',
      'hzVj4',
      'QFcHo',
      '3C5F4',
      'jAy74',
      '0Tjcz',
      '0b8Bw',
      'WyTEw',
      'W0AFf',
      'CkqbI',
      'yVvKW',
      'UZ7PR',
      'RgvWn',
      'L8FjJ',
      'SPNU5',
      'RknNX',
      'nkVR6',
      'Jzwtm',
      '1OzGV',
      'rh7XJ',
      '8HapA',
      'VCBrR',
      '9tFOO',
      'HTat5',
      'xTySz',
      '5tE2m',
      'fTXha',
      'yYV0Y',
      '6rduc',
      '1zclS',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorcwvdotmw',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '0w0JAG9JEeSp0iIAC12Jpw': {
    courseSlug: 'computational-neuroscience',
    computerLanguages: ['Python and Octave'],
    itemIds: [
      'SRruJ',
      'ozdXZ',
      '120xF',
      '66dUT',
      'YqRH1',
      'VGQAs',
      'oEJcr',
      'jFSbj',
      'uAneE',
      'Bwa9e',
      'XTHa7',
      '5wykU',
      'NZQ6W',
      'sHXED',
      'SAWzD',
      'NJiFS',
      'DIMwT',
      'PrtDL',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructortowtgqbj',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  XjmslaE3Eea7DQoksxKcjg: {
    courseSlug: 'python-data-processing',
    computerLanguages: ['Python'],
    itemIds: [
      'ybn3q',
      'BOHGF',
      '5qi9d',
      '1VgqB',
      '404wz',
      'sXrBt',
      'RDEom',
      '3I6ID',
      'FznOf',
      'v6Zge',
      'BCHDQ',
      'IwlqM',
      'idYzp',
      'B0SqN',
      'v34CY',
      'JXRse',
      'tYGoA',
      'mh5j0',
      'mRroL',
      'BtKSI',
      'TUHOm',
      'Hfjhc',
      '7ZXte',
      '8cvZL',
      '4YzkQ',
      'E5N5R',
      'PSkgo',
      'G7rZ9',
      'jWVkv',
      'UQP3T',
      'YS5e6',
      'G844K',
      'eBqfJ',
      'xeMmE',
      'PPjDv',
      'feBSy',
      'wltbx',
      'srQrD',
      '7iivW',
      'xsaww',
      'NeY1C',
      'KjgGZ',
      'lVZKr',
      'AgEre',
      'jbtkG',
      'Elj6O',
      'WRSmd',
      '41d51',
      'qTtOR',
      'Fm7kh',
      'xMQeE',
      'ehCmK',
      'j5oBd',
      'Kdl8x',
      'BtWLC',
      'Sa0VF',
      'NFV5d',
      'l43La',
      'XXJJx',
      '4qfa3',
      'QOLnr',
      'jM1I3',
      'vFp9I',
      'gE9zo',
      'MfNJt',
      '7aMZ4',
      'riXIU',
      'm9Tkt',
      '1bgTZ',
      'Gii8z',
      'TDwUT',
      'DGFBV',
      'etvwq',
      '0vnc5',
      'efep3',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructoremfrbxgp',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  Hc_NtRVGEeWhTg59fTWfpQ: {
    courseSlug: 'designexperiments',
    computerLanguages: ['R'],
    itemIds: [
      'rhjYI',
      '63jJp',
      '6u31H',
      'iSacW',
      'uO56p',
      'qQXog',
      '6LJNr',
      'V431w',
      'mJa9U',
      '8FAP3',
      'FpUtm',
      'dPUxu',
      '5R8rv',
      'usowh',
      '2eiZZ',
      '7ZHhL',
      'CugX2',
      'uhKkZ',
      'uB88r',
      'NxvDj',
      'fts6m',
      'Zur8l',
      'DmW12',
      'cVcyt',
      'LbgEM',
      'abPMs',
      'QxwsT',
      'rlgaq',
      'hUCVU',
      '3kvsY',
      'P8Nkq',
      'EfHpn',
      'e22WI',
      '0TTeX',
      '0MiJq',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorupdkqcuc',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  bfE3GBnoEeWg_RJGAuFGjw: {
    courseSlug: 'python-programming-introduction',
    computerLanguages: ['Python'],
    itemIds: [
      '7ftIJ',
      'Z2I3m',
      'hqUF9',
      '1n65g',
      'ywcuv',
      'tdkR7',
      'Uwojm',
      '7G4cZ',
      'KDMuJ',
      'ZtNk3',
      'VZoBB',
      'gB1Eq',
      'Sa48b',
      'BJ5rn',
      'vUB0G',
      'XcPbu',
      'FT1TZ',
      'ojrIL',
      'hSEKY',
      'b4s1C',
      'qFNS4',
      'cBKku',
      'lOPqa',
      '6XkqY',
      'QCPu4',
      'SYmho',
      'RbFS7',
      'UFmAy',
      'gz722',
      'mhwR4',
      'yWnav',
      'Hgb6T',
      'Xz9PC',
      '2QnDz',
      'aOrUd',
      'ZvEGi',
      '7UukR',
      'wwHqB',
      'lN10q',
      'smQ9M',
      'PbAst',
      'DrrSw',
      'g8n9B',
      'Hpf9x',
      'YsVjh',
      'WxnWV',
      'igbp2',
      'HEiwO',
      'tP7BF',
      'xmZ1E',
      'EiJ8o',
      'M49Zd',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorlbljvunq',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'Xpv78UYjEeemlQrrzf9X-A': {
    courseSlug: 'object-oriented-design',
    computerLanguages: ['Java'],
    itemIds: ['UWzyk', 'kJnLJ', '36FFW', 'vy2A0', 'piok8', 'RgLUj', 'e98J9'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorwsucsaek',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  senhGTbqEeWw6g4yTrGrVQ: {
    courseSlug: 'machine-learning-data-analysis',
    computerLanguages: ['Python'],
    itemIds: [
      'Ub2x1',
      'MCNOu',
      'A6JHK',
      'HpcYx',
      'TkhbT',
      'HP5Gm',
      'MHeuR',
      'NMhtT',
      'uZTZQ',
      'yHOYj',
      'vv8zv',
      'nIopV',
      'KKkc0',
      'lTaYF',
      'Me3O3',
      'eTO92',
      'ilhof',
      '0PTeX',
      'aqEsh',
      'MMg4w',
      'qihLx',
      'Ebb2M',
      'XJJz2',
      '0y9ri',
      'jHz9s',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructoryzdyfdga',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  lYw3nxuGEeWo5g5SXpDA8Q: {
    courseSlug: 'crypto',
    computerLanguages: ['Python, C/C++, and Java'],
    itemIds: ['OMCWA', 'KZ9js', 'fofQp', 'EJ69R', '5zRcK', 'cZHEY', 'L14eH'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructormeghmzes',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  hTD2gasoEeikbA5NFwCang: {
    courseSlug: 'algorithms-data-collection-code',
    computerLanguages: ['C'],
    itemIds: [
      'cI1Mm',
      '7dvUm',
      '595i3',
      'qWDHB',
      'xRuat',
      '3mGSa',
      'KlFAz',
      'he3wS',
      'LMAaS',
      'SGfhI',
      'nPPwW',
      '4MLsp',
      '009uo',
      'iz9ig',
      'NzAHN',
      'B4bQe',
      'IDmMa',
      'BWgmN',
      'SeVVF',
      'sDMXY',
      '51NB4',
      '1xFuW',
      '3DSMd',
      'OHNpH',
      'VXXpy',
      's1OD8',
      'SrPRf',
      'w9tv7',
      'YZkpe',
      '8cFx7',
      'wcYxM',
      'qCvnv',
      'VzB9u',
      'Rp2Vf',
      'FAIte',
      'VsgsI',
      'Y2VHE',
      'dzltT',
      'Yf9fM',
      'XOxod',
      'GrwC9',
      'WOUbq',
      '4tGun',
      'pUct7',
      'yywLj',
      'alN3r',
      'LQaex',
      'zH0Gb',
      'tcSMe',
      'eed8m',
      'cDrTl',
      'kgfoQ',
      'MecbV',
      'XMOI6',
      '7dvUm',
      '595i3',
      'qWDHB',
      'xRuat',
      '3mGSa',
      'KlFAz',
      'he3wS',
      'LMAaS',
      'SGfhI',
      'nPPwW',
      '4MLsp',
      '009uo',
      'iz9ig',
      'NzAHN',
      'B4bQe',
      'IDmMa',
      'BWgmN',
      'SeVVF',
      'sDMXY',
      '51NB4',
      '1xFuW',
      '3DSMd',
      'OHNpH',
      'VXXpy',
      's1OD8',
      'SrPRf',
      'w9tv7',
      'YZkpe',
      '8cFx7',
      'wcYxM',
      'qCvnv',
      'VzB9u',
      'Rp2Vf',
      'FAIte',
      'VsgsI',
      'Y2VHE',
      'dzltT',
      'Yf9fM',
      'XOxod',
      'GrwC9',
      'WOUbq',
      '4tGun',
      'pUct7',
      'yywLj',
      'alN3r',
      'LQaex',
      'zH0Gb',
      'tcSMe',
      'eed8m',
      'cDrTl',
      'kgfoQ',
      'MecbV',
      'XMOI6',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructordgwvfrqj',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  B7S6P6yjEeaPvQ5eOPtN_A: {
    courseSlug: 'bootstrap-4',
    computerLanguages: ['Bootstrap 4'],
    itemIds: [
      '0hPqo',
      'cgWKo',
      'LkZXk',
      'kXErq',
      'oWCkZ',
      'OPtYt',
      'e9axj',
      '39PTK',
      '36yqj',
      'zZFV1',
      'Ow3tC',
      '5dEHJ',
      '7UjCF',
      'DP5FX',
      'omyzt',
      'Lt62U',
      'WPs62',
      'StwXQ',
      'z46f4',
      'aRDkz',
      'ZjMEL',
      '7V2hr',
      'wUjIf',
      'Q2amj',
      'FNIDB',
      'nIb73',
      'hWE5b',
      '6uMvP',
      'SIHkS',
      'mLaHL',
      'YL7cj',
    ],
    launchPath: '/',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructordzpdxuns',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  HgkJY4M6Eeehbwo96zvH1A: {
    courseSlug: 'geometric-algorithms',
    computerLanguages: ['Python, C++, Java'],
    itemIds: [
      'wxxla',
      'NyPj8',
      'dfZit',
      'aibwv',
      'BSm2I',
      '8PAKf',
      'yLaAT',
      'aZVem',
      'dFhiD',
      'v1ANR',
      '4drVN',
      'b7QNN',
      'j5J5g',
      '0miU0',
      'mG8rQ',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructoraoguhjdk',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '7-OlHzcAEeaG4w4uSkT3yQ': {
    courseSlug: 'social-media-data-analytics',
    computerLanguages: ['Python and R'],
    itemIds: [
      'P9060',
      'fcoSM',
      'aHgqc',
      'scaAn',
      '96A44',
      'eBXPh',
      '9FhDO',
      'GiUyP',
      'rs7Oh',
      'ezFsa',
      'CIzyc',
      'HC93Q',
      'hfelS',
      '4pizU',
      'aq1As',
      'S1Wft',
      '0T0mw',
      's9CdR',
      'klrAQ',
      '3rdHk',
      'rt9Dh',
      'p0td0',
      'vvKZN',
      'ilZlC',
      'C4mPt',
      'qZRuv',
      'Y5W0u',
      'PYyvB',
      'UBscV',
      'x6CyX',
      's7DjM',
      'aF8PU',
      'gwFnT',
      'V1ssh',
      'Jc8uc',
      'VDiSI',
      'gxIVo',
      'IQTB1',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorfrrnofhk',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  THkzKaBPEeWm9xJA1YXcWQ: {
    courseSlug: 'discrete-optimization',
    computerLanguages: ['C++, Java, and Python'],
    itemIds: ['TvXJx', 'npnKe', 'puP82', '0tD43', 'sUgcy', 'GywH2', 'ewEUu'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorqvnqhuhg',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  D6KIxUkLEeuZGAr_TcQGiQ: {
    courseSlug: 'scala2-functional-programming',
    computerLanguages: ['Scala'],
    itemIds: [
      'KJX8A',
      '7xLKH',
      'UzicG',
      '8LrWd',
      'xIz9O',
      'uV974',
      'ebKWU',
      'hNpAD',
      '7mkuF',
      'RMA2S',
      '8wxyE',
      'XqRJ7',
      'JjcbK',
      'kROFm',
      'Kpc9I',
      'VFM6A',
      'nKKjy',
      'f6IQm',
      'FQDE1',
      'rBgEI',
      '51t1e',
      'xuM1M',
      'fOuQ9',
      'zj5Mt',
      '0AMxq',
      '5mmJP',
      'TIIQj',
      '6WD2X',
      'sqr2n',
      'YDsaZ',
      'HH19P',
      'gK7io',
      'n2EWV',
      'KvSC2',
      'dnreZ',
      '8ZaPo',
      'cdHAM',
      'TFjsY',
      'XYlER',
      '0uFfe',
      '82wi4',
      'UWSpZ',
      'UpWlj',
      '5scUh',
      '6U42a',
      'd0fdt',
      'JIPKx',
      'H3cKk',
      'weqsE',
      '5vUiM',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorftiqmrrf',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  YfjiOHROEeWLqw7zlLhRzQ: {
    courseSlug: 'statistical-inference',
    computerLanguages: ['R'],
    itemIds: [
      'W7eNv',
      'DSJ1B',
      'yeGPr',
      'uGgql',
      'CTiHk',
      'DM2JW',
      'g8mGN',
      'cM8h5',
      'xZ9y5',
      'VcHGU',
      'seH4i',
      '1KvcA',
      'Rwp1J',
      'lZtOt',
      'a6Z8l',
      '3k8j5',
      'vlxx2',
      'BC6vm',
      'cPih8',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructornttjsbrn',
    excludeBranchIds: [],
  },
  IZF1UGcfEeuI4Aqy1at7YQ: {
    courseSlug: 'javascript-basics',
    computerLanguages: ['HTML and Javascript'],
    itemIds: [
      'ItDer',
      'Ff15D',
      'fVUej',
      'oNuTe',
      'R2lbG',
      'sNqop',
      'ddqlM',
      'apAv7',
      'j5uwn',
      'UFIf6',
      '9vGxW',
      'APK0C',
      '77W5F',
      'KUOol',
      'X0C3H',
      'vqjCB',
      'Joro6',
      'o1kcs',
      'vqikT',
      'egqJP',
      'fEU7L',
      'hwPfU',
      '5jeNR',
      '9clcg',
      'RPt7v',
      'OvE0Y',
      'YwSC3',
      'zw7Am',
      't6avv',
      'zx0Cu',
      'BBGFD',
      'ecvns',
      'DE9W8',
      'DKJek',
      'syPgb',
      'ubCWb',
      'B62dR',
      'x3Bey',
      'vgaR8',
      'H91Uz',
      'nrpoO',
      'DCOHD',
      'lUNQX',
      'V57aW',
      'NsF7D',
      '289T0',
      'b1lGG',
      'YrkUa',
      'SmITu',
      'YIHod',
      '43TVi',
      'PkaFc',
      'QRcIS',
      'I0zbU',
      'thJcX',
      'HpFJj',
      'fh1zQ',
      'dPpBJ',
      'TOTXS',
      'TvHTT',
      'rDafh',
      'cyBQV',
      '1kyFB',
      'Mxqqn',
      '4Ljvq',
      'HSglP',
      'DhwZE',
      'df2Sl',
      'uVUzw',
      '1YVEC',
      'BtSW7',
      'VJCCx',
      'JqTRL',
      'g4gK7',
      'j1M6s',
      'VpXsH',
      'WRAUF',
      'j1M6s',
      'G76pN',
      '3euh8',
      '9H4S4',
      'VpXsH',
      'h9569',
      'OSjvu',
      'bCU5S',
      'tww2T',
      'LTy0G',
      'q4iVR',
      'D2III',
      'Unfzv',
      'hSPIN',
      '3cK8s',
      'qhvcN',
      'ByeEj',
      'MiZ1Z',
      '3yPXg',
      'lgOGd',
      'vJy5J',
    ],
    launchPath: '',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructoresehdhax',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  sIzu4R5yEeaCoQrM2bnbCQ: {
    courseSlug: 'julia-programming',
    computerLanguages: ['Julia'],
    itemIds: [
      'BW4HP',
      'RxqNC',
      'piqzG',
      'MhRvb',
      'LI6Oq',
      'tjqCf',
      '5IZh6',
      'VON1F',
      '2ezwj',
      '8Ho1v',
      'bgokr',
      '5WLKq',
      '2FYip',
      'sVm17',
      '3Y4w2',
      '4D0rQ',
      'KF9OG',
      'yGMkr',
      'nEs99',
      'bzm6r',
      'aUI5C',
      'WicxO',
      'nLG09',
      'WvQlt',
      'hQrBg',
      'MUQvO',
      'U8hSf',
      'o8wAQ',
      'Xb6FO',
      '7KgMV',
      'BMDiC',
      'mgaYB',
      'kZ5mG',
      'MjUjQ',
      'CnJp2',
      'HujmR',
      'lP5ZA',
      '4GuD2',
      'MB4J7',
      '0o6RL',
      'KNMCh',
      '3AfFS',
      'bKw1v',
      'fBgdP',
      'sTW9q',
      'ECt49',
      'aBlnP',
      'NXfjW',
      'JvKVS',
      'Xm6HA',
      'gsQZi',
      'dtbo8',
      '6rPdy',
      'GZgsd',
      'SHasL',
      'Lq2WP',
      'tM5Wi',
      'aiKAS',
      'FHHqr',
      'msnEv',
      'Ttvtm',
      'plNUc',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorltfmuksl',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'NFiJtRnpEeW9dA4X94-nLQ': {
    courseSlug: 'object-oriented-java',
    computerLanguages: ['Java '],
    itemIds: [
      'MU90r',
      'xJ82A',
      'wZGwp',
      'J6m8F',
      'aJbgS',
      'eZIfJ',
      '0kv8I',
      'rIUH7',
      'PPPMf',
      '6OWKU',
      'JtaMv',
      'XkQdj',
      'ks7ZG',
      'zqSRy',
      '25UM6',
      'VLwq0',
      'f1CgB',
      '78GNI',
      'H0TCb',
      'RuNtE',
      'DM8nA',
      '5TCfB',
      'gOFlb',
      'BK6f4',
      'lYYTz',
      'lKEVe',
      'mqFZ3',
      'hS2ks',
      'TE8Q3',
      'Twnjk',
      '9ZcT1',
      'jM4KS',
      'Jisbc',
      'Dv57N',
      'ugZhc',
      '1lRwl',
      '7Wknb',
      'cJeWQ',
      'UzK5I',
      'GM727',
      'JGcYi',
      '3C14J',
      'oIHOc',
      'i3cBw',
      'kWhyW',
      'L6RN9',
      'LldsM',
      'vPLXL',
      'ltZFN',
      'EUBIS',
      'rZiwc',
      '8aQR0',
      'k1wae',
      'HbWDE',
      't3AYu',
      'j78Ax',
      'bng86',
      'dDLeg',
      'Bi6tU',
      'BpSMN',
      'fLj2j',
      'CxXp0',
      '2DdNX',
      'FvDHF',
      'ogpIn',
      'h75Dw',
      'hADNH',
      'C1mcK',
      '5NA0S',
      'QHiQe',
      'MqukN',
      'GafmM',
      'YKQqC',
      'SS15B',
      'DPbYO',
      'VwPea',
      '8wnrd',
      'T0pRL',
      'iqRy4',
      'lc1ml',
      '0T1Yp',
      'E8OXw',
      'tDaDh',
      '5nJfE',
      'nG51T',
      'LMXIA',
      'GdA42',
      'j3FBx',
      'BmCrM',
      '3V8d6',
      'b8gMh',
      'oVpx3',
      'lq9lt',
      'RChXD',
      '6GuGF',
      'kxBFz',
      '3HUEH',
      'pf36g',
      'PP6hQ',
      'Ksdbk',
      'M9Rv7',
      'Zmla4',
      'ZpQKJ',
      'h0FUn',
      'z3w51',
      '70OEf',
      '6DxFj',
      'PtXch',
      '1TAVU',
      'uxusc',
      '5QcoZ',
      'HesWh',
      '3jRAC',
      'CnUkx',
      'HiLGF',
      'sUG3f',
      'UDeZt',
      'UG1YU',
      'XEvqA',
    ],
    launchPath: '',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorxwrfbfia',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  mUSYT5noEeWqkw5zNB248Q: {
    courseSlug: 'bioconductor',
    computerLanguages: ['R'],
    itemIds: [
      'Z97Nn',
      'ywuJl',
      'yZWBB',
      'QQelv',
      'cwD4y',
      'gpb3w',
      'frkzh',
      'BVKrp',
      'VvQ9j',
      'pFBnE',
      'M7pDd',
      'VEZzN',
      'utERu',
      'Wv4ZL',
      '14MRA',
      '6gWuS',
      'xdRH9',
      'cXsWM',
      'E57YU',
      '7DmGf',
      '8MzY8',
      'pjldP',
      'BXJOP',
      'YepPp',
      'Fr1G0',
      'hQTs7',
      'ldfCA',
      'qAQGP',
      'j3lXq',
      'vcV3q',
      'N1xBf',
      'C4dNr',
      't6PLD',
      'tG7Sr',
      'NwmHA',
      'aoNwW',
      'xSQqw',
      'XVfPX',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructormcquixtx',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '3c1bSkIJEeWpogr5ZO8qxQ': {
    courseSlug: 'ml-classification',
    computerLanguages: ['Python and Machine Learning'],
    itemIds: [
      'NtMAS',
      'cddwS',
      'gLYyI',
      'zU6HO',
      '5MWIa',
      'eHHDd',
      'jp0Yp',
      'diZFx',
      'bpHt8',
      'c4ssq',
      'ssPTc',
      'xHRYe',
      'seWHJ',
      'WxrJw',
      'AqDoX',
      'NDTdJ',
      'xRbhG',
      'fEDCt',
      'aMrDF',
      'FgzAt',
      'UTPiQ',
      '3TYwk',
      '0Z2ax',
      '6DQQh',
      'pGfWZ',
      'ObhEq',
      'ZQ1aY',
      'UWEJn',
      'hJdXC',
      'JisIQ',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorifhdhinh',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '7zlrfeNdEeafIArLeQBXwg': {
    courseSlug: 'python-programming',
    computerLanguages: ['Python'],
    itemIds: [
      'B8fNC',
      'obsbz',
      'BVUBe',
      'ZIPSG',
      'idRw1',
      'ncOxX',
      '3vOwe',
      '4Se7Z',
      '2qRPZ',
      'tAq8o',
      '9CLOH',
      'Yx3m0',
      '96Kyb',
      'q9Ye9',
      'L6PqS',
      'QODwA',
      'ieRxq',
      'Gr7bZ',
      'bpEwL',
      '9aMBh',
      'GcA4C',
      '1rrj7',
      'Jmqwk',
      'eZe6C',
      'f5wH1',
      'SRICS',
      'ywa22',
      'YA7H9',
      'EiEac',
      '2VNq8',
      '0CMAb',
      '876jN',
      'fqltB',
      'ohxhn',
      'A3DgS',
      'pY1T7',
      '1FfjM',
      'WVjt1',
      'SVcUt',
      'dVsLl',
      'uGDrc',
      'OuShh',
      'LaO1c',
      '2N7AL',
      'pUScZ',
      'JM1ML',
      'wjDKd',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorehtlnknq',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  q4jrAUR4Eea5xg7_DSTNnw: {
    courseSlug: 'r-data-visualization',
    computerLanguages: ['R'],
    itemIds: [
      'MKdcU',
      '3OQXD',
      '1FG1D',
      'Mm7Sd',
      '9OkNU',
      'VeFwn',
      'YlF7i',
      'Sj95L',
      '3zeOF',
      'irIL7',
      '1hmio',
      'yuvdm',
      'nkoeG',
      'gbInJ',
      'xhWDT',
      'OFjN8',
      'uLZBl',
      'Zupq5',
      'otm8K',
      'cKmVS',
      'UA302',
      's0ZTv',
      'vuTjw',
      'dkj0s',
      'hdEOv',
      'VcXlQ',
      'TAkLN',
      'XQXxp',
      'AHTqK',
      'g3daF',
      'Qbmaz',
      'zjS82',
      'YjQU4',
      'ZRqLm',
      'LxGBT',
      'VEVSl',
      '2Wi5B',
      'So6sU',
      '5x0QJ',
      'TAv0N',
      '52oti',
      'kjUXv',
      'io1to',
      'K0wu3',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorcoiinsib',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  nQ5d7TbQEeWW9BKhJ4xW0Q: {
    courseSlug: 'html',
    computerLanguages: ['HTML5'],
    itemIds: [
      'MbPkP',
      'wsxd5',
      'Dlayy',
      'BCsCq',
      '6YX4i',
      'ua1UG',
      'NxaOr',
      '7Wvrg',
      'CIR2e',
      'HtqUe',
      'blrRu',
      'a0yq0',
      '5HnFB',
      'WqvSN',
      'afqDD',
      'Ct8Hy',
      '4dOi4',
      'oJyXt',
      '50L7P',
      'hIMvz',
      'EQVpd',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructordfmvmnvb',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  oSAFEslDEeWCSBJ1_yk7Tw: {
    courseSlug: 'linear-regression-model',
    computerLanguages: ['R'],
    itemIds: [
      'oulKD',
      'KNX5b',
      't29d4',
      'A5gbk',
      'y8kQ2',
      'LDoCh',
      'aelUc',
      'JmQ5c',
      '3xJHn',
      'NTEaw',
      'oulKD',
      'A9eKx',
      'sbMIR',
      'HH2Dz',
      'KNX5b',
      '9ce6b',
      'gIqqL',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorhnvnvfea',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  ouoDtVM7EeaUyhJ5kBsouw: {
    courseSlug: 'linear-models-2',
    computerLanguages: ['R'],
    itemIds: [
      'UdxYC',
      'cuNQG',
      'tcr47',
      'MC5vl',
      'vcs5P',
      'rtpkN',
      'mqQf2',
      'oJAw7',
      'mXcMZ',
      'vh7BF',
      'pYQix',
      '03OHF',
      'uPmLV',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorwlqfbdag',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  Clt2FokTEeiYQAqwENY34g: {
    courseSlug: 'basic-data-processing-visualization-python',
    computerLanguages: ['Python'],
    itemIds: [
      'bgPnb',
      'sQ264',
      'aA2xq',
      'fVoxt',
      'zH60B',
      'z1zDe',
      'DWNcJ',
      'gnCgU',
      'SXH0y',
      'ZoyID',
      'AW3kK',
      'yjJeK',
      'sET7v',
      'wWxGz',
      'qZsBw',
      '5yDkb',
      'MlIs1',
      '2tiQ0',
      'zFhvv',
      'otyZo',
      'Enl0k',
      '6wYyR',
      'Dj9Nw',
      'hjvOt',
      'kW78N',
      'hmH4B',
      'VfbyE',
      '7ozmb',
      'BRJmD',
      'RbecB',
      'jTUvF',
      'DB9uO',
      'JOJMx',
      'OV5so',
      'iriUo',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorbqolomok',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  y9cRQS5YEemZvxKL2M8ZqA: {
    courseSlug: 'sql-data-science-capstone',
    computerLanguages: ['SQL'],
    itemIds: [
      'Iukfs',
      'QpHN9',
      'fKJ36',
      'qOm9N',
      'XYXyK',
      'wxRTR',
      'z7Udr',
      '3uF18',
      'xE6eG',
      'PcDoj',
      'N8ah5',
      'Ud1dK',
      'JpAA6',
    ],
    launchPath: '',
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructornrrfjrik',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '3mA6QTIyEeWsOA5fzAmxbw': {
    courseSlug: 'predictive-analytics',
    computerLanguages: ['Python and R'],
    itemIds: ['ROLOs', '7A5tl'],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorgajuqupd',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  CJs0DTk_EeWYbg7p2_3OHQ: {
    courseSlug: 'javascript',
    computerLanguages: ['HTML, CSS, Javascript'],
    itemIds: [
      'JM3Bi',
      'fMApf',
      '35Oja',
      'c7grG',
      'TafNU',
      '2wVYF',
      '2fCqw',
      'D7R3j',
      'Ch7Pn',
      'Ltkbl',
      'NWlLT',
      'Ir9pR',
      '28x9J',
      'cyA9U',
      'klU5G',
      '0WIL8',
      '2VjBX',
      'LKFqI',
      'KgbIm',
      'xQRc9',
      'LhVoE',
      'i4227',
      'ZO1SL',
      'OvLMp',
      '46RnR',
    ],
    launchPath: '/',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorqvmohiii',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  lJgyVBhjEeammQ6NfVLBSw: {
    courseSlug: 'data-analytics-business',
    computerLanguages: ['SQL and creating Entity Relationship Diagrams (ERDs)'],
    itemIds: ['RwYuf'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorzfjogxsi',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  kaEEZo2KEeWFxA4DZNEJOQ: {
    courseSlug: 'c-plus-plus-b',
    computerLanguages: ['C++'],
    itemIds: ['yBdiM', 'PcgEo'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorhnloobhc',
    excludeBranchIds: [],
  },
  VRRFmnCSEeuGxgrFdetpfQ: {
    courseSlug: 'pythonforcybersecurity-introduction',
    computerLanguages: ['Python'],
    itemIds: [
      'LHMPD',
      'ragpj',
      '7IM0s',
      'Io82w',
      'qVoA8',
      'WxNe8',
      'GuGEQ',
      '9UfHq',
      'yjKQZ',
      '2iWCN',
      'eLPTr',
      'w55rT',
      'PwoOx',
      '22hp3',
      'nLYWC',
      'GEWrl',
      't6crB',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructornpsyzdmy',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  u3goXsk9EeWT3Aqsn0BGnQ: {
    courseSlug: 'inferential-statistics-intro',
    computerLanguages: ['R'],
    itemIds: [
      '3EKw7',
      '8oBeE',
      '38XPc',
      'fGGAo',
      'TRNOq',
      'AQaTA',
      'CmS8Y',
      '1AoRh',
      'bKH5a',
      'e6sd9',
      'x2K8l',
      'Of72k',
      '5XfZl',
      'CD62o',
      'PkUTl',
      'E4GZE',
      'rsk1O',
      'QtxkB',
      '6K0KG',
      'riGi7',
      'zXz3t',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorhnovgegp',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  yG1EARC8EeiWoAqBnMlvMg: {
    courseSlug: 'front-end-react',
    computerLanguages: ['React'],
    itemIds: [
      'XjQZl',
      'nkOQi',
      'km6NK',
      'lwfpx',
      'Cb0se',
      '996so',
      '8YC7e',
      'KqNHn',
      'k92ZA',
      'wiObL',
      'dLbRz',
      'X2eeR',
      'CmStz',
      '39mcF',
      'ptyN7',
      'ivQry',
      'oHw3Z',
      '9GSIO',
      'Q3UOZ',
      'OyUO4',
      'vQeQs',
      'PSbMZ',
      'qp3A0',
      'PYeZk',
      '1eC3w',
      'IEFsA',
      'kLieG',
      'I1qo9',
      'lXvuA',
      'X9VVn',
      'J1zTN',
      'GuH6S',
      'RpfBq',
      'STzhv',
      'IWHie',
      '4fMTp',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructordqqgbxmk',
    excludeBranchIds: [],
  },
  g4sFEnitEeaCZBIelfdoiQ: {
    courseSlug: 'probabilistic-graphical-models-3-learning',
    computerLanguages: ['Octave'],
    itemIds: ['YwG0o', '0FwbG', 'pAQkj', 'iLbRk'],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorjibxjwqr',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  c_rkuRoBEeWDtQoum3sFeQ: {
    courseSlug: 'duke-programming-web',
    computerLanguages: ['HTML, CSS, Javascript'],
    itemIds: [
      'wxAGk',
      'MpmNs',
      '4hKA3',
      'lv2Tb',
      'YU87q',
      'bZTpG',
      'drrbY',
      'QqURA',
      'XwS1Y',
      'N0JV6',
      'xApiL',
      '4x9Bk',
      'y1JUW',
      '9nsBb',
      'mroby',
      'yEvZM',
      'qQ3sU',
      '4PXSk',
      'qG6LI',
      '3szKF',
      'n4DpV',
      'xslqb',
      'yV2lV',
      'oUvMH',
      '0vplX',
      '8m6tK',
      '6QtRx',
      'eq3SX',
      'dNItH',
      '2ofli',
      'QRXD4',
      'DTAbI',
      '1V4kL',
      '9iUp6',
      '60TZT',
      'SA0fq',
      'E5oWG',
      'ZECaT',
      'fmvCn',
      'cdFDr',
      'Ki9iN',
      'kqGRL',
    ],
    launchPath: '/',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructoreyytdpjz',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  bRPXgjY9EeW6RApRXdjJPw: {
    courseSlug: 'scala-functional-programming',
    computerLanguages: ['Scala'],
    itemIds: [
      'BNOBK',
      'PkGLn',
      'Sauv3',
      'uV974',
      'KPiGt',
      'EoeMo',
      'DV6Vv',
      '5y1CP',
      'Edqdi',
      'xL0rP',
      'bZ7Cg',
      'vZRw5',
      '0K7cz',
      '89qyl',
      'KE7Uy',
      'mHhiP',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorrlvsalid',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '6EAVDavbEeaPvQ5eOPtN_A': {
    courseSlug: 'what-is-a-proof',
    computerLanguages: ['Python'],
    itemIds: [
      'SeaCH',
      'LowcM',
      '9GGMC',
      'oSIAI',
      'FCsca',
      'KEJ9R',
      'UtWRC',
      'g28f1',
      'lz7vE',
      'aGPYW',
      'yoGRq',
      'Zp7dt',
      'a3S86',
      'nHKxv',
      'SApm7',
      'Fgkwr',
      'YBbGC',
      'WwJVX',
      'SEOZ6',
      'XYbuy',
      'tknSb',
      'LxlL0',
      'p3Tnh',
      'AiES4',
      '1GIug',
      '20Lfx',
      'dNhSF',
      'v4Fzf',
      'friW2',
      'KMhgu',
      '9ZHea',
      'zuxpW',
      'w9Uok',
      'VYhWB',
      'OPyaT',
      'cEeDe',
      'YiULQ',
      'f9lHP',
      'lSyIj',
      'KSERZ',
      'MOkjG',
      'EtqH2',
      'ePs0t',
      'NKW7a',
      'WKjKW',
      'GPU1i',
      'CT1Rt',
      '4XpPh',
      'V5KXZ',
      '8hMz6',
      'bwRmb',
      '28vFI',
      '4AFaE',
      '4EVfV',
      'eKLTx',
      '2UM9n',
      'uBbsP',
      'FobOQ',
      'geIFs',
      'pS9bO',
      '9L2BR',
      'ZTfWI',
      '8GVQW',
      '3xgP0',
      'Mr5Q3',
      '9GPPO',
      'SsYVp',
      'a4e2d',
      '29yjh',
      'IrGKH',
      '2y2sL',
      '66xYH',
      'Tow5C',
      'ELuE2',
      'VylPo',
      'pHH1B',
      'Si9oO',
      'lS9KX',
      '24RVt',
      '5AsJs',
      'rLjpn',
      'HE8Qa',
      'zdzpX',
      '8YIJE',
      'giksk',
      'z7yco',
      '8ac0c',
      'zJYzk',
      'mbuxN',
      'uqlUU',
      'NmqKA',
      'ca5QF',
      'NeIFG',
      '0EOMl',
      'aO7XQ',
      'OB2Eo',
      'rddlX',
      'MYqQp',
      '2DYVj',
      'Z3FSB',
      'VN75Z',
      'm241A',
      '9kr3d',
      '9vek8',
      'ZiCMI',
      'NWOa8',
      'BjIhc',
      'NXPKL',
      'ECeTz',
      'nNHYI',
      'jJaQo',
      'vOgnk',
      'rs0sl',
      'Aa0NB',
      'Btqry',
      'JIx6d',
      'Uf5Bl',
      '9qp2t',
      'QqY98',
      'iaOBS',
      '0Cgyc',
      'nGEMQ',
      'qUKYH',
      'iPMnL',
      'iyUda',
      'YTVlP',
      'A0QVA',
      '02Yfl',
      'eSLLd',
      'tLDGa',
      'VjH3j',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorhlefhqrm',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  MxUmEBtIEemj1w6Mo8vnSg: {
    courseSlug: 'secure-coding-principles',
    computerLanguages: ['C and C++'],
    itemIds: [
      'PJjEe',
      'S85Vj',
      'W5HN6',
      'WHH1x',
      'ThjI3',
      '7Czfx',
      'tCexW',
      '4jgDh',
      'MLvTO',
      '9M57j',
      '6JBns',
      '8YCtX',
      'x8wTO',
      '3eRjf',
      '245GG',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorjgxxymig',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '1BM3lirjEeWLVg5w1LoYqQ': {
    courseSlug: 'erasmus-econometrics',
    computerLanguages: ['R'],
    itemIds: [
      '3Uvkp',
      'LpYkH',
      'Y8KE2',
      'qpLNE',
      'E6GX4',
      'UOEoD',
      '7ZB1m',
      'JsYrq',
      'nQHYN',
      'T7Lr2',
      '1w8Hc',
      'GsHfF',
      'SGSdL',
      'p4Cu6',
      'AeCx7',
      'CcNoQ',
      'zuvrl',
      '9i9ps',
      'zWDB3',
      'SSLvN',
      'FzgOW',
      'E5Jga',
      'XslYA',
      'g0D5z',
      'zB5ON',
      '6nXYu',
      'Xl60x',
      'jpjrg',
      '8vBEZ',
      'XCx8K',
      'bhq2x',
      'tmCfs',
      'QD3EO',
      'jvINx',
      'tlK22',
      'ylxHE',
      '9257O',
      'vLFsS',
      '6MWEs',
      'FhSCA',
      'jAAsa',
      'z7nuE',
      'dcgvg',
      'C1kMf',
      'FDjvD',
      'SwFrT',
      'JlyRj',
      '7V5Ub',
      'dGNi6',
      'Lnn9I',
      'FJzt2',
      'E2d79',
      '6GJCB',
      'ox2sn',
      '9GOAq',
      'i6HEe',
      'KLFmJ',
      'DK6L3',
      'xH0GN',
      'x6ILW',
      'gvvqF',
      'dVgBw',
      'R8KkC',
      'Qmonm',
      'TWbGb',
      'wFj8K',
      '72ZCg',
      'Fllml',
      'JATsz',
      'e9bpo',
      'siGbV',
      'CmrN2',
      'G2uKB',
      'BUhRJ',
      'Jy1Lb',
      'lWFdj',
      'TBxpe',
      '7cvPR',
      'elYGW',
      '5AnBa',
      'DJNW1',
      'Stjsr',
      'hb8on',
      'krLzU',
      'WUeaK',
      'R23qv',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructormdnmqryh',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '-4ffSHNYEeWIfhKr_WcYsQ': {
    courseSlug: 'reproducible-research',
    computerLanguages: ['R'],
    itemIds: ['gYyPt', 'OMZ37', 'AZ1Su'],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorjbmqbnjq',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  bR6kwyKtEeapkBKJ0Y_FqQ: {
    courseSlug: 'business-analytics',
    computerLanguages: ['R'],
    itemIds: ['QrQU2', 'MsZ8m', 'UFsSG', '5jsBx', 'zqMV7', 'EvCRr', 'DwFmm', 'cHzTo', 'ZHiSA'],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorpxzkbwxz',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'u41Z-k3PEeWjfw5p9aPb_w': {
    courseSlug: 'biostatistics-2',
    computerLanguages: ['R'],
    itemIds: [
      'x0yVf',
      'nCvMx',
      'V9Ozc',
      'NPE9O',
      'q6cmt',
      'kTGPA',
      'mp8ry',
      'Qftpp',
      'PWygf',
      'Na03A',
      'fgfaz',
      'Y6RwH',
      'fDsxj',
    ],
    launchPath: '',
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorwwkufigk',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  Gyll8Zh9EeWZyg6bf_Oxkw: {
    courseSlug: 'dna-sequencing',
    computerLanguages: ['Python'],
    itemIds: ['Q0vk0', '9huXm', 'DPXyP', 'PRQsG', 'rD1W4', 'TR8jC', 'lfcsg', 'muyRc', 'WTaMb', 'Cm0Rm'],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructortzcgiqud',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  GVy8tIIKEeWXmQ4F86nmrw: {
    courseSlug: 'scala-parallel-programming',
    computerLanguages: ['Scala'],
    itemIds: [
      '9eyNl',
      '5ntXK',
      'haDDl',
      'SnC7q',
      'gM5Y4',
      'JrVJg',
      'OV52m',
      'iKwa2',
      'gShha',
      'BFPvX',
      'oe4BK',
      'gU4Fb',
      'fvhqA',
      'E4ImD',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorovlderxz',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '2dHcFsRdEeW2JxKnR3RyOw': {
    courseSlug: 'probability-intro',
    computerLanguages: ['R'],
    itemIds: [
      'tZd24',
      'T6iBP',
      'AnqBP',
      '71RLl',
      'BUOS7',
      'VHl5Q',
      'swnHi',
      '1E7zQ',
      '1lZY9',
      'AXYvG',
      'kDpFQ',
      'VFSMG',
      '3dZte',
      'WIDVb',
      'JKwGo',
      'iheFb',
      'g8UIa',
      'w5Fn0',
      'cKeaV',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructoriwqkgaij',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'bqIN8mI-EeqE-g67Q4kWZw': {
    courseSlug: 'jhu-data-visualization-r',
    computerLanguages: ['R'],
    itemIds: [
      'jFezf',
      'lbiXK',
      '5gDNz',
      'wQJtG',
      'rmUD3',
      'y3I5L',
      'DslFS',
      'Az2b4',
      'vioqv',
      'nVyNX',
      'Y2UYF',
      'IDrZ3',
      'MBGdS',
      'uv4pZ',
      'JTPuc',
      'ANL2b',
      'xMkI2',
      'g0LRB',
      'miZ80',
      'O7Ao2',
      'hRITD',
      'hjpy0',
      'JGjwb',
      '0lSQN',
      '3vDcB',
      'OLeXm',
      'mFBkR',
      'B6A4H',
      'xtEBt',
      'u2s9Y',
      'FfvAK',
      'E17nM',
      'FtskC',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructortexixcso',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  dB1qehnoEeWwrBKfKrqlSQ: {
    courseSlug: 'java-programming-design-principles',
    computerLanguages: ['Java'],
    itemIds: [
      'Yyrxg',
      '03Pyh',
      'uHMvB',
      'SCjMx',
      '3RkuE',
      'GkcpD',
      'yzFlm',
      'Ip7kU',
      'XtprJ',
      'vrfa7',
      'PQjIJ',
      'yxqMb',
      'fA6FH',
      '8YLE5',
      'NqDrf',
      'j9Aa1',
      'tRQm6',
      'WxyPU',
      'OnNGh',
      'DYuOT',
      'PjUwz',
      'kiHfx',
      'Imrlz',
      '1ekjx',
      'xToQx',
      'r7oOP',
      'n1DIm',
      'oXWzh',
      'qeH43',
      'wkafw',
      'NRoO9',
      'qhlBG',
      'cajch',
      '3Vbci',
      'ikapQ',
      'e6Xuz',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructortzvxcqmz',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  H02KsW1DEeWXrA6ju0fvnQ: {
    courseSlug: 'practical-machine-learning',
    computerLanguages: ['R'],
    itemIds: [
      'PvInj',
      '9bErA',
      '0O6OG',
      'LTLYF',
      'PvInj',
      'R43St',
      '3SSqy',
      'Bu9ns',
      'RbGRq',
      '0vwNS',
      'JpopA',
      'HwIgT',
      'qLHuK',
      'QU66P',
      '9z2Hp',
      'oraKV',
      'EALzX',
      '6V3fC',
      'XKsl6',
      '9mGzA',
      '0KF0Q',
      'HYzfz',
      '9vHkV',
      'YvBxt',
      'DHyia',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorpiyyhyfu',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  B8E2c3blEear9RKoJLO5Cw: {
    courseSlug: 'algorithms-divide-conquer',
    computerLanguages: ['Algorithms'],
    itemIds: [
      'WeBy2',
      'srsxO',
      'BvMTA',
      'YLbzP',
      'h06aN',
      'h06aN',
      'KD8cm',
      'AUmUg',
      'Odmer',
      'LN70k',
      's0KO3',
      'yl6kU',
      '4JmFc',
      'Geunn',
      'hK4jW',
      'z9kDR',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorljrzzvsx',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  hVoJYnQ_EeWIfhKr_WcYsQ: {
    courseSlug: 'web-development',
    computerLanguages: ['HTML, CSS, JavaScript'],
    itemIds: [
      'sIiPa',
      '858qA',
      'TcrsX',
      'B0LpB',
      'qk39b',
      '4iuBt',
      'l2b0A',
      'eBfpN',
      'LcPQX',
      '7jJQC',
      'TLrkw',
      '4CqAq',
      'NzCzf',
      'mxiP7',
      'aaEhc',
      '9hNO9',
      'Owtab',
      'ssDho',
      'BLzAn',
      'GTRPx',
      'ZonHV',
      'ZonHV',
      '4qBcQ',
      '5ouE6',
      'KbJRA',
      'eq7SB',
      'aJFMX',
      'Uzino',
      '8tgbp',
      'qUYt0',
      'tNmLt',
      'shBDJ',
      'lyLil',
      'nVKVz',
      'V4cBD',
      'jzSgj',
      'TEtwN',
      'L6C33',
      '3skTp',
      'rtcjo',
      'FpMv6',
      'SPMnP',
      'FaTNl',
      'k8OJQ',
      'ioCX6',
      'syApr',
      'aRgCu',
      'sIkgm',
      'D6YBr',
      'MdtAv',
      'bOOCV',
      'LXmhg',
      'r44HA',
    ],
    launchPath: '',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorhyadhaup',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  EA0hyTUGEeWWBQrVFXqd1w: {
    courseSlug: 'web-application-development',
    computerLanguages: ['JavaScript and MongoDB'],
    itemIds: [
      'e0TCB',
      'go2jO',
      'Ee3QK',
      'GHU72',
      'jk0BO',
      'm86FR',
      '9tJJT',
      '5T8cA',
      '1EAZv',
      'oM7oY',
      '1XLmf',
      'amr1s',
      'VJuZB',
      'vQDEm',
      'EG0SS',
      's9ho8',
      'OuKaO',
      'QEvdW',
      'nVGXM',
      'OwKE8',
      '80lWz',
      'vahWe',
      'Y59Qn',
      'QQNsm',
      'MuXRp',
      'wqrx2',
      'Wi0fT',
      'XCPkh',
      '3bMc9',
      'nHn1g',
      'RzVsW',
      'xKv0F',
      'pfEj0',
      'DfsVN',
      'dObA8',
      'GBizJ',
      '3uXZW',
      'tgEqY',
      'ARtko',
      'm67tI',
      'dny9k',
      'xWlx6',
      'BP1uO',
      'pziOW',
    ],
    launchPath: '',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructortnrflryt',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  Fp0K8RoEEeWDtQoum3sFeQ: {
    courseSlug: 'responsive-web-design',
    computerLanguages: ['HTML, CSS, JavaScript'],
    itemIds: [
      '0avtb',
      'Z1lmv',
      'qAxsP',
      'eqmao',
      'snJlL',
      'iDSm8',
      'rJorq',
      'Mfi3C',
      'rCSTy',
      'bF8zR',
      'Jwcd3',
      'PsIdS',
      'rrnL0',
      'mnfnc',
      'Wa4OB',
      'Gz7DD',
      'LcHWj',
      'X1xAS',
      'ZLvtA',
      'cuXKi',
      'bTul9',
      '64WG4',
      'uwt7F',
      'ImlJz',
      'NrfQU',
      '86e7h',
      'SWGyx',
      'KsjIb',
      'UJAf7',
      'JmYDG',
      'RpjPN',
      'yyved',
      '7H301',
      'ogRbj',
      '3xlQw',
      'Jl3fs',
      'uaBzm',
      'pY5lM',
      'jnKeR',
      'UOqWr',
      'hrZPs',
      'GiPno',
      'WXu9a',
      'PP1Gj',
      'TcPTY',
      'psIo6',
      'QkMqJ',
      'WofnR',
      'ZmcOG',
      'ibAeR',
      'R73pD',
      'rmReC',
      'E6KpQ',
      'yE2YS',
      'pVzeZ',
      'J7XrL',
      '8pvCG',
      'fujqz',
      'q7Hec',
      'nedSL',
      'Vdi5S',
      'UNELH',
      'jV72m',
      'kFWlh',
      'Sz7C2',
      'y8SET',
      'M2Liv',
      'yPLPX',
      'KKdql',
      'w4vpQ',
      'vCPr9',
      'QX8a1',
      'ib5gr',
      'tItUx',
      'jPGqX',
      'RZNY5',
      'lNfV1',
      'hhFto',
      'ecyQr',
      'KYBa3',
      'ZVWuE',
      'fyBHM',
      'RuV4b',
      'QxHOP',
      'mReHC',
      'FHMZU',
      'IdzJA',
      'ZR9I0',
    ],
    launchPath: '',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorrhvxavxf',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  Pv40_UR4Eeawjgp7XHTShQ: {
    courseSlug: 'advanced-r',
    computerLanguages: ['R'],
    itemIds: [
      'Pjrf6',
      'hNzQ9',
      'qL0ZX',
      '6oM4t',
      '0wG76',
      '7kMkn',
      'xvb5D',
      'YHFKA',
      'XNi1P',
      'FtHrB',
      '4BQe7',
      'hhLfz',
      'huGfz',
      '5TmEw',
      'S9fwk',
      '8hfBO',
      'CcCx7',
      '3NnJL',
      'WeGqg',
      'NseAf',
      'Cn1qd',
      'KAHgG',
      'F8d3d',
      'lJg9y',
      'rbeR4',
      'ixoSD',
      '4Kwov',
      'tobmd',
      'liTbC',
      'Lcp47',
      'TTYCQ',
      'HpLqW',
      'zkiAQ',
      'LrAyO',
      'pYMRa',
      'Fsk2M',
      'KgFGB',
      'OEh2N',
      'mjDxv',
      'fWF9G',
      'jik61',
      'D5CmV',
      'gdXHX',
      'rQh7H',
      'qshSl',
      'LqMTa',
      'xfzIA',
      '6U9Y3',
      'sWRBn',
      'lU9HV',
      'UuvCh',
      'zkDK4',
      'nB3s4',
      'EjHfh',
      '7tCnj',
      'rNQcq',
      '98rUI',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorvarzavpv',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  wKPtohoHEeWwrBKfKrqlSQ: {
    courseSlug: 'meteor-development',
    computerLanguages: ['Meteor.js'],
    itemIds: [
      'LMP07',
      'jup38',
      'XpX9v',
      'mcaIO',
      'so7BI',
      'GPZbj',
      '5RNfp',
      '7P0Ir',
      'dJH3r',
      'VYgu9',
      'qwRRb',
      'dpUSg',
      '1hFfF',
      'LerJW',
      '90oMK',
      'YIH1R',
      'ZhDsS',
      'EknDd',
      'dI2v6',
      'q3LMC',
      'qdUoO',
      'Tm6lx',
      'J0UZa',
      'oT86A',
      'W7bag',
      '3p5KN',
      'k8gZw',
      '26wQN',
      'xe6zX',
      'hOOti',
      'kAzbv',
      'YIuvd',
      'hZwo6',
      'Z82hd',
      'Sg6lA',
      '7rwy2',
      'UBIMn',
      'Hpx8V',
      'RTZiF',
      '1Wfpa',
      'AD73c',
      'jU2EW',
      '7Swyg',
      'sD6F7',
      '3H2Tq',
      'PODtn',
      '0PKNZ',
      'KZsMy',
      '0DzCH',
      'nHxGT',
      'PLVEd',
      'J3UBg',
      'FqUSL',
      'GWSdu',
      'EzWFp',
      '9fMFp',
      'J9BS5',
      'eQmhx',
      'wHae7',
      'ZAlEe',
      'Qj1uQ',
      'Pc2UB',
      '82VpW',
      'SA2Rr',
      'HCnYB',
      'd465e',
    ],
    launchPath: '',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorjkqopwyy',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '4Zbh5ZhSEeWqkw5zNB248Q': {
    courseSlug: 'python-genomics',
    computerLanguages: ['Python'],
    itemIds: ['yw1Aw', 'YZlGv', 'gxCoT', 'O1eiV', '0NEkW', 'KFZx4', 'WAMz9', 'lg0Zs', 'uFIyD'],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorplvtvfjm',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  fuFdqqrEEeeQCg4vdZhqYg: {
    courseSlug: 'golang-getting-started',
    computerLanguages: ['Go'],
    itemIds: ['ZC9eh', '01wGe', 'f1Cly', 'sLPZg', '0xyF8', 'CHgQd', '8Opxw', 'si70V', '83a1t', 'zE5EV'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorfrdmbvmt',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  m8BEnbnZEeewUQ7IuhPUJA: {
    courseSlug: 'golang-concurrency',
    computerLanguages: ['Go'],
    itemIds: ['iGFWx', 'RAJ0V', 'PP5Gk', 'meeiu', 'y8ii2', 'MAemV'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorqwbhvnkn',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  qvkru5bqEeigcQ6ACV18LA: {
    courseSlug: 'approximation-algorithms',
    computerLanguages: ['Python, C++, Java'],
    itemIds: ['Lhh5r', '7hAjH', 'femZX', 'AxVNj', 'mb2Ac', '7rLcG'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorowqldpab',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  zN_XyjlAEeWCYBKNeFwojw: {
    courseSlug: 'web-design-project',
    computerLanguages: ['HTML, CSS, Javascript and Bootstrap'],
    itemIds: ['jBJMg', '5b3oM', 'prXqn', 'pVoe0', 'ZbGgC', 'UuvoI'],
    launchPath: '/',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructoremmtzvkv',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  M9dntkEoEeWZtA4u62x6lQ: {
    courseSlug: 'c-plus-plus-a',
    computerLanguages: ['C++'],
    itemIds: ['J7AWc', '1WzYR', '8Wdkc'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructoryyvflfwv',
    excludeBranchIds: [],
  },
  'UgLIu2I-EeqAwwq-BbrWcQ': {
    courseSlug: 'jhu-getting-started-data-viz-r',
    computerLanguages: ['R'],
    itemIds: [
      'sLSjl',
      '1Jrxq',
      'z29gC',
      'q1Wwz',
      'rKMBR',
      'FFnlx',
      'f7Vkx',
      '5sI2r',
      'SjSH9',
      '3nKV3',
      'E160R',
      'cQt3V',
      'nrhLE',
      '2p8eO',
      'cjPeZ',
      'MdCPB',
      '2H6XL',
      'dhgZS',
      '3CdEc',
      'LY4A2',
      '5GtzP',
      'xVlQP',
      'L7o86',
      '5VqmI',
      'VCQib',
      'y5dyd',
      'MtVze',
      'AyMW5',
      'pWjZM',
      'jZ4sK',
      'Cx4jJ',
      'cqoxQ',
      'BG9TD',
      'qFKqc',
      'F2Xvr',
      'ERNqg',
      'KrAHZ',
      'zlfok',
      'qbF8t',
      'pNHqh',
      'fxYUV',
      'iQUiO',
      'UekBg',
      'UdY0Z',
      'yHvz8',
      'qFnAb',
      'ozrgv',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructoryluvfyul',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  xRA5cxnoEeWg_RJGAuFGjw: {
    courseSlug: 'dwrelational',
    computerLanguages: ['PostgreSQL'],
    itemIds: [
      'Jrla5',
      'rwGHl',
      'qSoUl',
      'TyOyW',
      'zoMJv',
      'FOuno',
      'MKcWC',
      'zUkR6',
      'U9jsg',
      'RJ49Q',
      'PAe1A',
      'VLU9Z',
      'vTg3j',
      'JkLlI',
      'j5Zci',
      '5T9IG',
      'y3qEb',
      'vIHS1',
      'Rkfv8',
      '9SHUv',
      'TSigv',
      'tX8Un',
      'IKdTV',
      '3vKnr',
      '1VOwi',
      'fuoF1',
    ],
    launchPath: '/lab',
    labApplicationName: 'JupyterLab',
    instructorWorkspaceId: 'instructordcwruvam',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  o4yIjxxHEeWo5g5SXpDA8Q: {
    courseSlug: 'learn-to-program',
    computerLanguages: ['Python'],
    itemIds: [
      'Jq3A2',
      'n0hWA',
      'ifEep',
      'bb5Aw',
      'ojiIo',
      'UpvRK',
      'aGRJ7',
      'bI05C',
      'K8KkY',
      '76Cqa',
      'OZOPS',
      'Motiw',
      'yWYCH',
      'mogax',
      'BDjtO',
      '2K59k',
      'bSSRZ',
      'iYLq2',
      '8zY60',
      '0sdDO',
      'PmwOO',
      'EWgtq',
      '0pDrK',
      'BqxPF',
      'bqoyO',
      'kGzBh',
      'kGZlM',
      'cnG7T',
      'w0jnq',
      'ehAGC',
      'NH3kE',
      'qdDGH',
      'qdDGH',
      'qdDGH',
      'xSlNA',
      'SweVM',
      'axCIC',
      'uOTjm',
      'Tt8wA',
      'U0Ob1',
      'Je4cH',
      'VxbiQ',
      'J7vJn',
      'UnnWk',
      'S3pvx',
      '6EjNw',
      'fgRkJ',
      'c2oXV',
      'BWKwj',
      'RyFMW',
      '0RazJ',
      'dLUSM',
      'xr2dL',
      'P3gAy',
      'jXRRa',
      'NX514',
      'tQmH5',
      'lU9R2',
      'z2RLs',
      'QZCTY',
      'OK9u9',
      'OK9u9',
      'OK9u9',
      'wSnmR',
      'Sc07u',
      'r11w9',
      'MkGIv',
      's1uE6',
      'SQAhQ',
      '3Jret',
      'ZBRAV',
      '2D4wF',
      'nxqvh',
      'oApXv',
      't8wv0',
      'xFJ2e',
      'MgRIr',
      'C19E4',
      'ZTEhu',
      'y56ST',
      'flUWJ',
      '7dgZ9',
      '0Uv2F',
      'ukPT7',
      'APnLM',
      'FsBQ1',
      '5BqJX',
      't9e8V',
      'CzIsc',
      'RTBSx',
      'IO1Gh',
      'IO1Gh',
      'IO1Gh',
      '4ShAN',
      'NC5TZ',
      'TZyjp',
      'x9uXX',
      'QIj4i',
      'kXHox',
      '2Jkod',
      'Y6c90',
      'OzBc8',
    ],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorelbajtkx',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'R1xPlXlzEeW3pg6oA-kqJQ': {
    courseSlug: 'algorithms-on-graphs',
    computerLanguages: ['Algorithms, Java, C++ and Python'],
    itemIds: ['AUd0k', 'X5n4w', 'qSk7g', 'vrbgU', 'DpmDw', 'nSER4', 'hD3Ic'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorxdmokfwe',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  ZearHHitEeaYNAqJlKFl8Q: {
    courseSlug: 'probabilistic-graphical-models-2-inference',
    computerLanguages: ['Octave'],
    itemIds: ['bTB5b', 'bwJdy'],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorzqhbqlkv',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  nreZLpQjEeqcUw5ApMKwQQ: {
    courseSlug: 'effective-scala',
    computerLanguages: ['Scala'],
    itemIds: [
      'vIEIl',
      'nWAdx',
      'UShnH',
      'jiQL9',
      'MT64m',
      'vujw6',
      'Y3zSS',
      'UTVcC',
      'adwoD',
      'AAvwb',
      'VxTAY',
      'Y1NKF',
      'goQXj',
      'GoEVe',
      'FhBzJ',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorhqlfswwv',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  PCO2sYdDEeW0iQ6RUMSWEQ: {
    courseSlug: 'scala-capstone',
    computerLanguages: ['Scala'],
    itemIds: ['FuSBC', 'tYqRU', 'RP4rn', 'wAolc', 'UOAKV', 'ctb91', '0i1IJ', '6E0Is', 'Ymsmh', 'JTplg'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructordmnypjbl',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  vCE8O6yREeiH3RLPiCMqUg: {
    courseSlug: 'workspaces-test',
    computerLanguages: ['R', 'Python 3'],
    itemIds: ['YzKaN', 'hjiU4'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructorihrfufqh',
    excludeBranchIds: [],
  },
  qi9mnkIJEeWC4g7VhG4bTQ: {
    courseSlug: 'ml-foundations',
    computerLanguages: ['Python'],
    itemIds: ['RP8te', 'phb1M', '6DeQc', 'XkB9D', 'sHK3J'],
    labApplicationName: 'Jupyter Notebook',
    instructorWorkspaceId: 'instructoraffzuvcx',
    excludeBranchIds: [],
  },
  a_xPWXNVEeWxvQr3acyajw: {
    courseSlug: 'regression-models',
    computerLanguages: ['R'],
    itemIds: [
      'tKnqi',
      '6Uczj',
      'u80a8',
      'JHGVu',
      'cy9Rm',
      'jncMq',
      'BjMqW',
      'BUqi6',
      'pe4za',
      'Geuex',
      'nUAOC',
      'f0Jto',
      'wEETK',
      'pPlFA',
      'eA2pV',
      '67c1O',
      '5S7KS',
      'q1CQq',
      'C9Opy',
      'kP2ia',
      'H5CIk',
      'dewH8',
      'nxntd',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorwtxnswqj',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'PeZYFz-zEeWB_AoW1KYI4Q': {
    courseSlug: 'scala-functional-program-design',
    computerLanguages: ['Scala'],
    itemIds: [
      'nwc4x',
      '9hAmw',
      'AYDPu',
      'YwLZp',
      '7sxvt',
      'AEOnG',
      'zsnJ0',
      'CRzdu',
      'zJcCG',
      'S7NQA',
      '98tNE',
      'lfFCQ',
      'bruI4',
      'RQKJu',
      'Hq4hg',
      'j6yMA',
      '0O7DM',
      'EkEqR',
      '0SDyy',
      'gsb05',
      '4ePw5',
      'FRznk',
      'a2EKl',
      'zQ7eh',
      'fX1pk',
      'aDQAD',
      'sbVjo',
      'DMuAg',
      '4z3vm',
      '7SSYu',
      'FCGoB',
      'FL6Fv',
      'bmwSc',
      'gMpcO',
      '7GvmT',
      'Gd31A',
      'Z0j9P',
      'gUDmc',
      'FfnDK',
      'ZmLWH',
      'pEsTy',
      '5lWVa',
      'fzgcf',
      '47S2g',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorulfbpslz',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  Qqmr3fBKEeWLaBLI8fdMlw: {
    courseSlug: 'bayesian-statistics',
    computerLanguages: ['R'],
    itemIds: ['1Qwe1', 'IOwTB', 'HHLnr', '6Ztvq', '4Nwq2', 'ZSJE5', 'BlhrT', 'Asjun', 'N3y39', '7uz4R'],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorcbuctoca',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  YyA0AhnoEeWwrBKfKrqlSQ: {
    courseSlug: 'java-programming-arrays-lists-data',
    computerLanguages: ['Java'],
    itemIds: [
      'fxqxm',
      'DvNzQ',
      '1UY6P',
      '727CD',
      'CNOsx',
      'DBSYj',
      'RMQFg',
      '6ZcSb',
      'AbpYj',
      '9yGTJ',
      '54Iig',
      'RnGtN',
      'YAV1j',
      'muuAe',
      'MEsTZ',
      'chV8J',
      'cAl9o',
      '4Umsg',
      'U4Bjv',
      'xGjL5',
      'TUvmY',
      'McxYj',
      'ygOPU',
      'xnES9',
      'Kh1WI',
      'od7mx',
      'oIRyD',
      'B1ENJ',
      'KGUVG',
      'e5ZZK',
      'QdyEn',
      'bMaD0',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorcunhuqfl',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '0HiU7Oe4EeWTAQ4yevf_oQ': {
    courseSlug: 'missing-data',
    computerLanguages: ['R'],
    itemIds: [
      'nRScQ',
      'sRGj1',
      '3dn1X',
      'sjAhR',
      'VG2Gr',
      'sHMRD',
      'D4Xwz',
      'N8zhZ',
      'filtT',
      'qH2xb',
      'OnKzC',
      '6xmDh',
      'JADhF',
      'y8CNK',
      '3swPX',
      'KK0eZ',
      'N6STE',
      'p5qO9',
      'rV1KI',
      'Hvo0C',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorkxrjoqyj',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  w7FFV3l0EeW53BJEfL52qQ: {
    courseSlug: 'advanced-algorithms-and-complexity',
    computerLanguages: ['Algorithms in Java, C++ and Python'],
    itemIds: ['106vi', 'm5JXm', 'SjztT', 'zW2VT', 'ESwzy', 'tJRvL', 'aM1sa', 'fxZov', '4kzYv', '9gpO7', 'beyWP'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorbajuugfz',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'B3r12dpIEemxgxKi9b-h7g': {
    courseSlug: 'c-structured-programming',
    computerLanguages: ['C'],
    itemIds: ['5wvrl', 'PzI5T', 'IM8bX', 'kTlWu', 'XoFZo', 'N9L44', '6BxII', 'oksx9', 'SLNwQ', '98HCf'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorxobdvozo',
    excludeBranchIds: [],
  },
  xS0pKcAFEeeMdgrf69Tp8A: {
    courseSlug: 'version-control-with-git',
    computerLanguages: ['Git'],
    itemIds: [
      'COD2g',
      'iqpYl',
      'AiSks',
      'dF2Zr',
      'ea4gj',
      'f9fbm',
      'KqYRY',
      'QaM9E',
      'AdPgN',
      'zBlSu',
      'OjWu9',
      'umjj0',
      'Ewi6x',
      'i5VLw',
      'Dx84X',
      'nv7Jn',
      'o8vxz',
      'Y0SDD',
      'yAsY8',
      'rwfGZ',
      'BSNHm',
      'jxfkW',
      'pK9Wb',
      'j9tQU',
      'cLDjx',
      'Hmjsz',
      'x6SW6',
      'PBKmh',
      'aK0aX',
      'iJ1ie',
      'UOQOf',
      'GEciH',
      'GUGFq',
      'yDY82',
      'C71VK',
      'R3ILp',
      'tbiLM',
      '4PQke',
      'Ja4fC',
      'bEdx0',
      'csXIR',
      'AZKTo',
      '6wr4f',
      'Miziw',
      '7daMz',
      'Ypbmn',
      'tVC5g',
      'kINuI',
      'DbIcc',
      'ztbsT',
      'cu5Fe',
      'tk5B5',
      'YwW2Q',
      '8BWIn',
      '43UxZ',
      'hfnpz',
      'nJwTc',
      'R8YC5',
      'SEJS1',
      'JdGxA',
      'gDroi',
      'RQkFZ',
      'zCzRW',
    ],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorcacpqlxt',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '3Vo3Am1LEeWMPAqsmzmVew': {
    courseSlug: 'data-products',
    computerLanguages: ['R'],
    itemIds: ['yOt56', 'a0uT1', 'cFNt2', 'NLn0H', 'JoASJ', 'a1Uy9'],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorcpgndrnm',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  '3nDDEZ8ZEeea2hIs8G-aOA': {
    courseSlug: 'golang-functions-methods',
    computerLanguages: ['Go'],
    itemIds: ['UxoIW', 'qKrnv', 'Z8tkv', 'gurxW', 'Cd0za', 'N70uE', 'cW9pa', 'zskdk'],
    launchPath: '/?folder=/home/coder/project',
    labApplicationName: 'VSCode',
    instructorWorkspaceId: 'instructorxuoczseb',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  jIaMzuYjEeWomRIq0eOZbw: {
    courseSlug: 'neurohacking',
    computerLanguages: ['R'],
    itemIds: [
      '7RxMU',
      'FckfY',
      'tHZ20',
      '3eyAl',
      'JS44V',
      'VDEI4',
      'o1Iu2',
      'bh73W',
      'T2Qlz',
      'WT3o4',
      'jMwgt',
      'LdBbJ',
      'zygt5',
      'sFcCq',
      'tWJIt',
      'qYSCT',
      'm2jYK',
      'iYrF0',
      'bfiTm',
      'Vt8Dk',
      'NDKHc',
      'ssiSw',
      '1D8dE',
      'Rw9kD',
      'JNPa2',
      'Yt1eA',
      'uynqA',
      'EkNcB',
      'vnPy1',
      'HRjXC',
      'ZJzO9',
      'QFeGX',
      'coQNY',
      'CSROU',
      'Dqi47',
      'vm1DA',
      'zdAwH',
      'SCJG8',
      'InNZq',
      'APsjr',
      'xFFgy',
      'rtoel',
      'Pw78J',
      'VCop1',
      '8pKWk',
      '8HrW3',
      'sXxtq',
      'x2oxf',
      'oFrjb',
      'lEsuD',
      'AaVdE',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorfweroome',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
  'pN1q2mI-Eeqcdg4GDbIftw': {
    courseSlug: 'jhu-advanced-data-visualization-r',
    computerLanguages: ['R'],
    itemIds: [
      'FhbAO',
      'PSyEF',
      'c5KML',
      '57lT9',
      'ERAaa',
      'Bs1Dp',
      'I5kIV',
      'nSrba',
      'fJAbK',
      'fDz1L',
      'WJyKK',
      '8LI97',
      'Gc8ZC',
      '6jrMX',
      'riV9U',
      'oicnL',
      'nWBai',
      'cAbvf',
      'hABPY',
      'AWKZt',
      'fCzLV',
      '4gvnv',
      'WI26O',
      'Og3ij',
      'gEPPD',
      'kTbVI',
      'YaokV',
      'vTsh5',
      'FDvWS',
      'VVMJG',
    ],
    labApplicationName: 'RStudio',
    instructorWorkspaceId: 'instructorrpczayze',
    excludeBranchIds: [],
    computerLanguagesAreProgrammingLanguages: false,
  },
};
/* eslint-enable camelcase */

export const getLabSandboxConfigurationForCourse = (courseId: string): LabSandboxConfiguration | undefined => {
  const maybeCourseConfig = labSandboxCourseConfiguration[courseId];
  if (maybeCourseConfig) {
    return {
      // Apply defaults.
      computerLanguagesAreProgrammingLanguages: true,
      ...maybeCourseConfig,
    };
  } else {
    return undefined;
  }
};

export const isLabSandboxEnabledForCourse = (courseId: string, branchId?: string): boolean => {
  const config = getLabSandboxConfigurationForCourse(courseId);
  const configExists = !!config;
  const branchIsExcluded = !!(branchId && config?.excludeBranchIds?.includes(branchId));
  return configExists && !branchIsExcluded;
};

export const isLabSandboxEnabledForItemInCourse = (courseId: string, itemId: string): boolean => {
  const config = getLabSandboxConfigurationForCourse(courseId);
  return !!config?.itemIds?.includes(itemId);
};
